export const en_strings = {
  'err.pattern.^0[1-9]\\d{6,14}$': 'The number must start with 0, followed by a digit from 1 to 9, and then 6 to 14 digits.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ\' .\-]*$': 'The field "{fieldName}" may only contain letters, accents, spaces, apostrophes, periods, and dashes.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\\s\\-\\.\'\(\)]*$': 'The field "{fieldName}" may only contain letters, numbers, accents, spaces, dashes, periods, apostrophes, and parentheses.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-\\s]+$': 'The field "{fieldName}" may only contain letters, numbers, accents, spaces, apostrophes, periods, parentheses, and dashes.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\'.,\(\)\- ]*$': 'The field "{fieldName}" may only contain letters, numbers, accents, spaces, apostrophes, commas, periods, parentheses, and dashes.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]*$': 'The field "{fieldName}" may only contain letters, numbers, accents, spaces, apostrophes, periods, parentheses, and dashes.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]+$': 'The field "{fieldName}" may only contain letters, numbers, accents, spaces, apostrophes, periods, parentheses, and dashes.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .()\\-]*$': 'The field "{fieldName}" may only contain letters, numbers, accents, spaces, apostrophes, periods, parentheses, and dashes.',
  'smartTable.paymentType': 'Payment Type',
  'tooltip.allNotes': 'View all notes',
  'tooltip.openDuplicate': 'Open the latest duplicate payment',
  'payment.openDuplicate': 'Open the duplicate',
  'smartTable.indicatifTelephoneNumber': 'Phone country code',
  'smartTable.phone': 'Phone number',
  'ask.noTimeSlotBooked': 'You have a request without an appointment. Would you like to book one now? This step is required to complete your application.',
  'place.warn_closure': ' All appointments scheduled on the newly closed days for this location will be cancelled, and affected users will be notified. Do you want to continue?',
  'calendar.mode.open': 'Open by default',
  'calendar.mode.closed': 'Closed by default',
  'calendar.regular_opening_days': 'Regular opening days',
  'calendar.exceptional_opening_days': 'Exceptional opening days',
  'calendar.time_ranges': 'Time ranges',
  'calendar.from': 'From',
  'calendar.to': 'To',
  'calendar.remove_range': 'Remove',
  'calendar.add_range': 'Add a range',
  'calendar.confirmReset': 'Do you want to reset all current settings?',
  'err.pattern.password': 'Password must contain at least two of the following: one lowercase letter, one uppercase letter, one number, or one special character.',
  'form.perm1.DYN.': 'Create an application',
  'global.pay': 'Pay',
  'smartTable.timeslot': 'Timeslot',
  'smartTable.requestReason': 'Request reason',
  'smartTable.passportType': 'Passport type',
  'refusalReason.desc.DYN.': '<p>Please provide a brief description of the reason for the refusal of this passport application.</p>',
  'timezone.notice': 'Appointments are scheduled based on the time zone of the appointment location.',
  'timeslot.noBooking': 'No booking timeslot has been made.',
  'timeslot.tooCloseToChange': 'You can no longer change this appointment because it is scheduled in less than {hours}h.',
  'session.inactive.title': 'Session inactive',
  'session.inactive': 'Your session has expired due to inactivity',
  'reactivateSession': 'Reactivate session',
  'global.changeTimeSlot': 'Change time slot',
  'supervisorAccountName': 'Supervisor account name',
  'err.supervisorAccountName.required': 'Supervisor account name is required',
  'scan.supervisor.desc': 'Please enter the account name of the supervisor to proceed with the following action:</br><b>{actionText}</b>',
  'scan.supervisor.noFingerprint': 'No fingerprint data found for this supervisor\'s account name',
  'outUsage.AB': 'This application is <b>out of its validity period</b>. Please direct the applicant to the kiosk or assist them in resubmitting their request.',
  'outUsage.C': 'This application is <b>out of its validity period</b>. Please close this request, then create a new entry for the applicant and proceed with the refusal.',
  'err.payment.notAvailable': 'This application is not available.',
  'form.PlaceOfBirth': 'Place of birth',
  'borderPass': 'Border pass',
  'urgent_pass': 'Urgent passport',
  'feedback': 'Feedback',
  'err.mustBeDifferentThan.errorValue': 'The field "{fieldName}" must be different than {errorValue}.',
  'DYN.PASSPORT_WRONG': 'Incorrect passport',
  'err.max.errorValue': 'The field "{fieldName}" must be less than {errorValue}.',
  'err.max': 'The "{fieldName}" field must be less than the maximum allowed value.',
  'err.min.errorValue': 'The field "{fieldName}" must be greater than {errorValue}.',
  'err.min': 'The "{fieldName}" field must be greater than the minimum allowed value.',
  'updateField.desc': 'Please provide updated information for the following field: <b>{field}</b>',
  'marital.status.engaged': 'Engaged',
  'payment_status.desc.DYN.passport_booked.toPay': 'The document application has been booked and still needs to be paid.',
  'payment_status.desc.DYN.passport_booked': 'The document application has been booked and paid.',
  'place.notExist': 'Place does not exist',
  'ApplicationForm': 'Application form',
  'BirthCertificate': 'Birth certificate',
  'ParentalAuthorization': 'Parental authorization',
  'printSettings.selected': 'You are modifying the print settings for the document: <b>{documentName}</b>',
  'print.settings.success': 'The print settings have been successfully updated for the document: <b>{documentName}</b>',
  'error.noHasFace': 'No face was detected in the picture. Please take the photo again.',
  'name.warn': 'The first name and/or the last name is empty or contains fewer than 2 characters.',
  'kiosk.redirect': 'Your nationality does not allow continuation in kiosk mode. Please sign in with an account to proceed. You will be redirected to the login screen.',
  'err.OtherPurpose.required': 'Other purpose is required',
  'print.qr.verification': 'Verification',
  'print.qr.application': 'Application',
  'print.terms': 'Terms and conditions apply.',
  'movements.empty': 'No movements have been recorded yet.',
  'movement.history': 'Entry/Exit history',
  'payment.notes': 'Notes',
  'payment.noNotes': 'No notes available',
  'extension.alreadyExists.warning': 'An extension already exists for this request. Are you sure you want to create a new one?',
  'payment.addNote.placeholder': 'Add a note…',
  'global.seeMore': 'See more',
  'global.seeLess': 'See less',
  'supervision.login.error': 'Supervisor verification failed.',
  'err.hostPhone.pattern': 'The phone number must start with + (country code) or 0 and contain 7 to 15 digits.',
  'reprintSticker': 'Reprint sticker',
  'err.daysGranted.min': 'The number of days must be at least 1.',
  'err.daysGranted.max': 'The number of days cannot exceed the number of days requested.',
  'err.daysGranted.required': 'The number of days is required..',
  'approval.daysGranted.error': 'Please enter a valid number of days.',
  'err.password.pattern': 'Password must contain at least two of the following: one lowercase letter, one uppercase letter, one number, or one special character.',
  'err.documentNumber.pattern': 'The document number must contain only letters, numbers, spaces, and hyphens.',
  'err.ExistingValidEntryReference.required': 'Existing valid entry reference is required',
  'BirthCountry': 'Birth country',
  'old': 'Old password',
  'firstName': 'First name',
  'email': 'Email',
  'paymentMethod': 'Payment method',
  'client.extended.softLockedOutLogin30Minutes': 'You have been locked out of your account for 30 minutes. Please try again later.',
  'client.extended.tooManyRequests': 'Too many requests. Please try again later.',
  'password': 'Password',
  'password2': 'Confirm password',
  'PreviousConvictions': 'Convictions',
  'Address': 'Address',
  'err.err': 'Error',
  'err.maxDateMilliFrom.errorValue': 'The field "{fieldName}" must not exceed the limit of "{errorValue}", defined by the field "{control}".',
  'err.maxDateMilliTo.errorValue': 'The field "{fieldName}" must be earlier than the limit set at "{errorValue}", defined by the field "{control}".',
  'err.mustBeEqualOrAfter.errorValue': 'The field "{fieldName}" must be equal to or later than the field "{errorValue}".',
  'err.mustBeEqualOrBefore.errorValue': 'The field "{fieldName}" must be equal to or earlier than the field "{errorValue}".',
  'err.maxDateMilliFromToday.errorValue': 'The field "{fieldName}" must not exceed {errorValue}',
  'err.dateLessThanNow': 'The date of the field "{fieldName}" must be earlier than today.',
  'err.dateGreaterThanNow': 'The date of the field "{fieldName}" must be later than today.',
  'err.minDateMilliFromNow.errorValue': 'The "{fieldName}" field must be a date equal to or later than {errorValue}.',
  'err.maxDateMilliFromNow.errorValue': 'The "{fieldName}" field must be a date equal to or earlier than {errorValue}.',
  'err.minDateMilliFromNow': 'The "{fieldName}" field must be a date equal to or later than the minimum allowed date.',
  'err.maxDateMilliFromNow': 'The "{fieldName}" field must be a date equal to or earlier than the maximum allowed date.',
  'err.mustMatch': 'The {fieldName} field must match the corresponding field.',
  'err.requireOneOf.errorValue': '{errorValue} must be provided',
  'err.requireOneOf.field': 'The field \'{name}\'',
  'err.requireOneOf.separator': ' or ',
  'err.pattern.^[0-9]{6,14}$': 'The "{fieldName}" field must contain between 6 and 14 digits.',
  'err.patten.^[0-9A-Za-z\\-\\s]{3,15}$': 'The "{fieldName}" field must contain 3 to 15 alphanumeric characters, dashes, or spaces.',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': 'The "{fieldName}" field must contain 7 to 20 characters: digits, spaces, dashes, or parentheses.',
  'err.pattern.^[0-9A-Za-z]{5,20}$': 'The "{fieldName}" field must contain 5 to 20 alphanumeric characters.',
  'err.pattern.^[0-9]{10}$': 'The "{fieldName}" field must contain exactly 10 digits.',
  'err.pattern.^[0-9A-Za-z]{5,20}': 'The "{fieldName}" field must contain 5 to 20 alphanumeric characters.',
  'err.pattern.^[0-9]{8,20}$': 'The "{fieldName}" field must contain 8 to 20 digits.',
  'err.pattern.^[A-Za-z0-9]{5,15}$': 'The "{fieldName}" field must contain 5 to 15 alphanumeric characters.',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': 'The "{fieldName}" field must be a valid base64-encoded JPEG or JP2 image.',
  'err.pattern.^[a-z]$': 'The "{fieldName}" field must contain a single lowercase letter.',
  "err.pattern.^[A-Z' -]*$": 'The "{fieldName}" field may only contain uppercase letters, apostrophes, spaces, and dashes.',
  'err.pattern.^[0-9-]{6,15}$': 'The "{fieldName}" field must contain between 6 and 15 characters (digits and hyphens only).',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': 'The "{fieldName}" field must be a valid email address.',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': 'The "{fieldName}" field must be a valid base64-encoded JPEG, PNG, WebP image or a PDF file.',
  'err.pattern.^[A-Z]{3}$': 'The "{fieldName}" field must contain exactly three uppercase letters.',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': 'The "{fieldName}" field must be a valid phone number, with or without area code, and may include spaces, dashes, or dots.',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': 'The "{fieldName}" field must be a valid international or national phone number (e.g., +1234567890 or 0123456789).',
  'err.pattern.^(?:\\+[1-9]\\d{8,9}|0\\d{8,9})$': 'The "{fieldName}" field must be a valid phone number with international format (+1234567890) or national format (0123456789), 9-10 digits after country code.',
  'err.pattern.^[A-Za-z\\s\\-]+$': 'The "{fieldName}" field may only contain letters, spaces, and dashes.',
  "err.pattern.^[a-zA-Z' -]*$": 'The "{fieldName}" field may only contain letters, spaces, and dashes.',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': 'The "{fieldName}" field may only contain letters, numbers, spaces, and dashes.',
  'err.pattern.^[0-9]*$': 'The "{fieldName}" field must contain only digits.',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': 'The "{fieldName}" field must be a valid date.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3}|0)$': 'The "{fieldName}" must start with + followed by 1 to 4 digits.',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': 'The "{fieldName}" field must start with an uppercase letter and may contain lowercase letters, accents, spaces, apostrophes, dashes, or periods.',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': 'The "{fieldName}" field must contain only letters (with or without accents), spaces, apostrophes, dashes, or periods.',
  'err.pattern.^[A-Z0-9]+$': 'The "{fieldName}" field must contain only uppercase letters and numbers.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': 'The "{fieldName}" field must start with a "+" followed by 1 to 4 digits (first digit cannot be 0).',
  'err.required': 'The "{fieldName}" field is required.',
  'err.maxlength.errorValue': 'The "{fieldName}" field must contain at most {errorValue} characters.',
  'err.minlength.errorValue': 'The "{fieldName}" field must contain at least {errorValue} characters.',
  'err.maxlength': 'The "{fieldName}" field is too long.',
  'err.minlength': 'The "{fieldName}" field is too short.',
  'err.pattern': 'The "{fieldName}" field has an invalid format.',
  'err.email': 'The "{fieldName}" field must be a valid email address.',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'BirthCity': 'City of Birth',
  'err.pattern.^\\+[1-9][0-9]{7,14}$': 'The "{fieldName}" field must start with a "+" followed by 8 to 15 digits.',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': 'Booking Confirmed!',
  'global.bookTimeSlot': 'Book time slot',
  'client.extended.maxMonthlyPaymentsReached': 'You have reached the maximum number of monthly payments. Please contact support.',
  'calendar.weekday.sunday': 'Sun',
  'calendar.weekday.monday': 'Mon',
  'calendar.weekday.tuesday': 'Tue',
  'calendar.weekday.wednesday': 'Wed',
  'calendar.weekday.thursday': 'Thu',
  'calendar.weekday.friday': 'Fri',
  'calendar.weekday.saturday': 'Sat',
  'calendar.month.january': 'January',
  'calendar.month.february': 'February',
  'calendar.month.march': 'March',
  'calendar.month.april': 'April',
  'calendar.month.may': 'May',
  'calendar.month.june': 'June',
  'calendar.month.july': 'July',
  'calendar.month.august': 'August',
  'calendar.month.september': 'September',
  'calendar.month.october': 'October',
  'calendar.month.november': 'November',
  'calendar.month.december': 'December',
  'calendar.timeline.no_slots': 'No time slots available for this day',
  'calendar.timeline.available': 'Available',
  'calendar.timeline.spots_available': 'spots available',
  'calendar.timeline.fully_booked': 'Fully booked',
  'calendar.confirm_booking_title': 'Confirm Booking',
  'calendar.confirm_booking_message': 'Please confirm that you want to book this time slot.',
  'calendar.booking_in_progress': 'Booking in progress...',
  'calendar.please_wait': 'Please wait while we process your booking.',
  'calendar.booking_error_title': 'Booking Error',
  'calendar.booking_success_title': 'Booking Confirmed!',
  'calendar.booking_success_message': 'Your time slot has been successfully reserved.',
  'calendar.proceed_to_payment': 'Proceed to Payment',
  'calendar.auto_proceed_message': 'Automatic redirection in...',
  'calendar.date': 'Date',
  'calendar.time': 'Time',
  'calendar.place': 'Location',
  'calendar.loading_month': 'Loading availability...',
  'extension.error.maxDays': 'You cannot request more than 30 days per extension.',
  'DYN.processed.NOTICES_ACCEPTED': 'Notice(s) validated',
  'notices_validated': 'Validated notices',
  'err.daysUntilReport.pattern': 'Days until report must have a correct format',
  'err.reportInterval.pattern': 'Report interval must be a number higher or equal to 0',
  'err.CompanionsSize.min': 'Companions size must be at least 1',
  'err.CompanionsSize.max': 'Companions size is too long',
  'global.error': 'An error occurred. Please try again. If the issue persists, please contact support.',
  'err.DurationOfStay.required': 'Duration of stay is required',
  'err.DurationOfStay.min': 'Duration of stay must be at least 1 day',
  'err.DurationOfStay.max': 'Duration of stay is too long',
  'DurationOfStay': 'Duration of stay (days)',
  'tooltip.acceptNotices': 'Validate the current notice',
  'notices': 'Notices',
  'ask.notices': 'Do you want to validate the notice ?',
  'accept.notices': 'Validate notice',
  'err.ModeOfTravel.required': 'Mode of travel is required',
  'err.FlightNumber.required': 'Flight number is required',
  'err.ShipNumber.required': 'Ship number is required',
  'err.CarNumber.required': 'Car number is required',
  'err.BusNumber.required': 'Bus number is required',
  'err.TrainNumber.required': 'Train number is required',
  'err.FlightNumber.pattern': 'Flight number must have a correct format',
  'err.ShipNumber.pattern': 'Ship number must have a correct format',
  'err.CarNumber.pattern': 'Car number must have a correct format',
  'err.BusNumber.pattern': 'Bus number must have a correct format',
  'err.TrainNumber.pattern': 'Train number must have a correct format',
  'ModeOfTravel': 'Mode of travel',
  'FlightNumber': 'Flight number',
  'ShipNumber': 'Ship number',
  'CarNumber': 'Car number',
  'BusNumber': 'Bus number',
  'TrainNumber': 'Train number',
  'DYN.flight': 'By plane',
  'DYN.ship': 'By ship',
  'DYN.car': 'By car',
  'DYN.bus': 'By bus',
  'DYN.train': 'By train',
  'DYN.foot': 'On foot',
  'expiredSinceTime': 'The application has been expired for <b> {days} days and {hours} hours ago </b>.',
  'tooltip.externalIndexedData': 'Multiple passports have been found for this person.',
  'customerName': 'Customer name',
  'visaDocumentsMaxTotalSize': 'The total size of the uploaded documents exceeds the maximum allowed size of {size}Mb. Please reduce the size of the documents and try again.',
  'help': 'Help',
  'unlimited': 'Unlimited',
  'download.logs': 'Download logs',
  'download.logs.tooltip': 'Download the complete logs of online and offline unusual activities. This file will be downloaded in JSON format and is mainly used for debugging purposes.',
  'ask.clear.storage': '<b>This action will perform a complete site data clearing, similar to Chrome\'s "Clear site data" feature.</b><br>This will clear: localStorage, sessionStorage, IndexedDB, Cache Storage, Service Workers, Cookies, and other browser storage. All data still in the queue will be downloaded into a JSON file before being cleared.<br><br>Are you sure you want to continue?',
  'clear.storage': 'Clear the storage',
  'clear.storage.tooltip': 'Clear all the locally stored data of the application',
  'payment.consume.placeNotAllowed': 'This application cannot be processed at this location. The traveller must proceed to one of the following locations: <br><b>{places}</b>',
  'application.placeAllowed': '<b>LOCATION RESTRICTION:</b> This document can only be processed at the following locations: <b>{places}</b>',
  'apply.overstay': 'Apply fee',
  'no_apply.overstay': 'No fee',
  'paymentUntil.gracePeriod': 'The following application is currently in the grace period, which ends on the <b>{date}</b>. <br><br> You may choose if the overstay fee should be applied or not.',
  'paymentExtension.overstay': 'This application is currently in overstay.<br><br><strong>Base Extension Price:</strong> {basePrice}<br><strong>Overstay Penalty:</strong> {penalty}<br><strong>Total with Penalty:</strong> {totalPrice}<br><br>You may choose if the overstay fee should be applied or not.',
  'consumeMode.transit': 'You are currently in <b>Transit mode</b>, applications will automatically be <b>processed IN and OUT at the same time</b>. This mode is used for travelers who are in transit and do not need to stay in the country.',
  'warn.payment.offlineApplication.quit': 'You are about to leave an offline application process. Are you sure you want to proceed?<br><br><b>All data will be lost.</b>',
  'payment_status.desc.offlineApplication': 'This application is currently being processed <b>OFFLINE</b>. Proceed with the process which will be sent to the synchronization queue once completed.',
  'continue': 'Continue',
  'global.changePassword': 'Change password',
  'signIn.forgotPassword': 'Forgot password',
  'signIn.title': 'Sign in',
  'global.notAccount': 'Don\'t have an account yet?',
  'global.continue': 'Continue',
  'signUp.title': 'Create account',
  'DYN.selectedPaymentMethod.VISA': 'You have selected to pay with <b>Visa</b>.',
  'DYN.selectedPaymentMethod.MASTERCARD': 'You have selected to pay with <b>Mastercard</b>.',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': 'You have selected to pay with <b>American Express</b>.',
  'DYN.selectedPaymentMethod.DINERS_CLUB': 'You have selected to pay with <b>Diner\'s Club</b>.',
  'DYN.selectedPaymentMethod.UNION_PAY': 'You have selected to pay with <b>Union Pay</b>.',
  'DYN.selectedPaymentMethod.ZIMSWITCH': 'You have selected to pay with <b>Zimswitch</b>.',
  'DYN.selectedPaymentMethod.PAYPAL': 'You have selected to pay with <b>PayPal</b>.',
  'DYN.selectedPaymentMethod.DISCOVER': 'You have selected to pay with <b>Discover</b>.',
  'ProvisionnalEntryPort': 'Desired registration point',
  'no.must_pay': 'Payment still required',
  'existingValidEntryReference.desc': 'This application contains a <b>valid entry reference</b>. That means that the traveler has already paid and been granted entry. Please make sure to check the validity of the reference before proceeding. If everything is correct, you can proceed with the check-in.',
  'ExistingValidEntryReference': 'Existing valid entry reference',
  'supervision.catC.ordinary.entry': 'CHECK-IN',
  'supervision.catC.ordinary.refuse': 'REFUSED ENTRY',
  'error.updatePassport': 'An error occurred while updating the application. Please try again.',
  'open.visaReference': 'Open linked application',
  'title.visaReference': 'Linked application',
  'print.extension': 'Print extension',
  'documents.load': 'Load all documents',
  'documents.add': 'Add missing document',
  'done.closeApplication': 'The application has been successfully closed. Would you like to create a new application based on this one\'s data?',
  'ask.closeApplication': 'This action can be used when a traveler can provide proof that an operation was completed offline, allowing this record to be considered resolved and discarded. Please confirm that you wish to close this request. This action is final and cannot be undone.',
  'approval.daysGranted.limit': 'The number of days granted cannot exceed the requested {days} days.',
  'approval.daysGranted.DYN.': 'Nr. of days granted',
  'print.alreadyPrinted': 'The documents of this application have last been printed on the {date} by the user {user}. Would you like to print them again?',
  'tooltip.printEvents': 'A list of all print events of this application',
  'printEventsCollapse': 'All print events of this application',
  'transactionReference.alt': 'Transaction Reference',
  'paymentType.alt': 'Payment tyPe',
  'changeGender.ask': 'The gender on the application must be changed to either Male or Female.',
  'print.askMultiple': 'Would you like to include all related documents in the printout?',
  'application.id': 'Application ID',
  'printSticker': 'Print visa sticker',
  'correctionFields': 'Following fields were corrected:',
  'corrected.desc': 'This visa application has been corrected by the applicant on the {date}.',
  'recentlyCorrected': 'Corrected',
  'visaValidFrom': 'Entry valid from',
  'visaValidUntil': 'Entry valid until',
  'online': 'Online',
  'offline': 'Offline',
  'issuingOfficer.alt': 'ISsuing officer',
  'placeOfIssue': 'Place of issue',
  'tooltip.hasBeenCorrected': 'This application has been corrected by the applicant.',
  'tooltip.extendStay': 'Extend the stay of the applicant',
  'form.importantRead': 'IMPORTANT - READ CAREFULLY',
  'form.completeInEnglish': 'To be completed clearly in English.',
  'form.selectApplicableFields': 'Select all applicable fields below.',
  'decisionLetter.title': 'Official Visa Decision Letter',
  'decisionLetter.approval.title': 'Visa application approved',
  'decisionLetter.refusal.title': 'Visa application declined',
  'decisionLetter.applicationId': 'Application ID',
  'decisionLetter.approvalDate': 'Approval date',
  'decisionLetter.refusalDate': 'Refusal date',
  'decisionLetter.dear': 'Dear',
  'decisionLetter.applicant': 'Applicant',
  'decisionLetter.documentType.application': 'Visa application',
  'decisionLetter.documentType.extension': 'Stay extension',
  'decisionLetter.logo.left': 'Department of Immigration',
  'decisionLetter.logo.right': 'Republic',
  'decisionLetter.actRef': 'Immigration Act',
  'decisionLetter.chiefDirector': 'CHIEF DIRECTOR OF IMMIGRATION',
  'decisionLetter.approval.body1': 'Your visa application has been approved.',
  'decisionLetter.approval.body2': 'Kindly present the QR code attached below upon your arrival at a Port of Entry (PoE).',
  'decisionLetter.refusal.body1': 'Your visa application has not been approved.',
  'decisionLetter.refusal.body2': 'If necessary, please feel free to resubmit a new application, ensuring that you address any issues that may have led to the refusal.',
  'decisionLetter.signature': 'On behalf of the Chief Director General of Immigration.',
  'printApprovalLetter': 'Print approval letter',
  'operation.REFUSEOUT': 'Refused check-out',
  'operation.REFUSEIN': 'Refused check-in',
  'error.closeApplication': 'An error occurred while closing the application. Please try again.',
  'closeApplication': 'Mark as closed',
  'tooltip.closeApplication': 'Mark the application as closed. This action is irreversible.',
  'understand': 'I understand',
  'ExtraDocument1': 'Extra document #1',
  'ExtraDocument2': 'Extra document #2',
  'ExtraDocument3': 'Extra document #3',
  'ExtraDocument4': 'Extra document #4',
  'ExtraDocument5': 'Extra document #5',
  'paperSize': 'Paper width',
  'change_lang': 'Change language',
  'queue.export.desc': 'Would you like to export the current queue to a JSON file. <b>Your local queue will be deleted after the export</b>. Are you sure you want to proceed?',
  'queue.export': 'Export to JSON',
  'queue.import': 'Import queue from JSON',
  'nationality': 'Nationality',
  'err.nationality.required': 'Nationality is required.',
  'gender': 'Gender',
  'HQReference': 'HQ Reference',
  'global.resetDefaults': 'Reset to default',
  'shortcuts.desc': 'You can set your own keyboard shortcuts below. Click on the key you want to set a new shortcut for and press the desired key on your keyboard.',
  'press.key': 'Press any key to set shortcut...',
  'dashboard.keyboardShortcuts': 'Keyboard shortcuts',
  'tooltip.changeShortcuts': 'Change the keyboard shortcuts',
  'global.changeShortcuts': 'Change shortcuts',
  'retake_picture': 'Retake picture',
  'error.faceCheck': 'An error occurred while processing the face match. Please try again.',
  'faceCheck.see_score': 'Face match',
  'recommendOrNot': 'Recommend or not',
  'recommended': 'Recommended',
  'not_recommended': 'Not recommended',
  'error.downgrade': 'An error occurred while downgrading the request. Please try again.',
  'done.downgrade': 'The request has been successfully downgraded.',
  'request.downgrade': 'Downgrade',
  'err.sendCodeEmail': 'Cannot send recovery code by email',
  'err.recover': 'Cannot submit recovery request: contact support with browser logs for more information.',
  'err.externalCode.pattern': 'External code (ICAO) must have a correct format: 4 uppercase letters',
  'request.extendStay': 'Extend stay',
  'ResidencePermitNumber': 'Residence Permit Number',
  'refusalReason.review.desc.DYN.visa': 'Please provide a brief description of the review as <b>NOT RECOMMENDED</b>. This description will be sent to the next reviewer.',
  'approveReason.review.desc.DYN.visa': 'Please provide a brief description of the review as <b>RECOMMENDED</b>. This description will be sent to the next reviewer.',
  'error.payment.noInternalReference': 'An HQ reference is required for this application to be reviewed. Please wait for the reference to be provided.',
  'request.revision': 'Would you like to activate the Autoskip? This feature will automatically skip the reviewed steps that don\'t require your input.',
  'notice.BORDER_PASS': 'Border Pass',
  'form.borderPassNumber': 'Border pass number',
  'form.dateOfBirth': 'Date of birth',
  'form.issueDate': 'Issue date',
  'form.authorizedCrossingPoints': 'Authorized crossing points',
  'form.issuedBy': 'Issued by',
  'form.externalCode': 'External code (ICAO)',
  'err.invoke': 'Error',
  'ask.pendingRequest': 'You have an awaiting correction. Would you like to open it now?',
  'entry.confirmation': 'Are you sure that all the information provided is correct? By clicking "Confirm", you will submit the application.',
  'free': 'Free',
  'tooltip.prepareLandingVisa': 'Prepare Landing Visa',
  'last_update': 'Last update',
  'count': 'Count',
  'tooltip.linkedExtensions': 'This is a stay extension. Click to view the details of it.',
  'tooltip.delayed': 'This request is delayed.',
  'movement.tooltip': 'View the details of the request movements.',
  'extension': 'Extension',
  'client.extended.badPaymentMetadata': 'The payment metadata is invalid. Please try again or contact support if the issue persists.',
  'DaysRequested': 'Days requested',
  'extensions.desc': 'Stay extension(s) awaiting review',
  'extend': 'Extend',
  'CheckboxVisaExtendFees': 'I confirm that the information provided is true and accurate and I agree to the stay extension fees, terms, and privacy policy.',
  'AttestantDocument': 'Attestant document',
  'AffidavitCustody': 'Affidavit of custody',
  'CopyOfEntry': 'Copy of entry',
  'DepartureTicket': 'Departure ticket',
  'DYN.Self': 'Self',
  'DYN.Spouse/Dependent': 'Spouse/Dependent',
  'DYN.Employee/Employer': 'Employee/Employer',
  'DYN.Co-Director': 'Co-Director',
  'DYN.Lawyer': 'Lawyer',
  'VisaReference': 'Visa reference',
  'ReasonForExtension': 'Reason for extension',
  'AttestantID': 'Attestant ID',
  'AttestantName': 'Attestant name',
  'AttestantPhone': 'Attestant phone',
  'AttestantEmail': 'Attestant email',
  'AttestantAddress': 'Attestant address',
  'AttestantRelation': 'Attestant relation',
  'start_extend': 'Extend the stay',
  'visaExtend.title': 'Stay extension',
  'days': 'days',
  'day': 'day',
  'kiosk.standby.text1': 'Start by filling in your declaration in just a few clicks on this tablet or online.',
  'kiosk.standbyDesc.text1': 'Before you begin, please note the following information :',
  'kiosk.standbyDesc.li1': 'You will be filling out an electronic form that collects your personal data and trip details.',
  'kiosk.standbyDesc.li2': 'All information provided must be accurate and match your travel documents (passport, visa, etc.).',
  'kiosk.standbyDesc.li3': 'After completing the form, you can proceed directly to the immigration counter with your identification document(s).',
  'kiosk.standbyDesc.li5': 'If you have any difficulties, feel free to ask staff at the border post for assistance.',
  'kiosk.standbyDesc.text2': 'Click "Start" when you are ready to complete your entry declaration.',
  'kiosk.success.title': 'Application Successfully Submitted',
  'kiosk.success.text1': 'You can now proceed to the immigration counter with your travel documents. An officer will conduct the final checks and validate your entry into the country.',
  'kiosk.success.text2': 'If you have any questions or difficulties, feel free to ask for assistance from the staff available.',
  'confirm.revision': 'Confirm revision',
  'print.isDone': 'Has the notice been successfully printed? Please make sure to provide the printed notice to the applicant.',
  'form.hostPhone': 'Host phone',
  'transit': 'Transit',
  'conditionalEntry': 'Conditional entry',
  'departure': 'Departure',
  'form.paragraph': 'Paragraph',
  'form.dateOfRefusal': 'Date of refusal',
  'form.purpose': 'Purpose',
  'form.host': 'Host',
  'form.officer': 'Officer',
  'form.reportAt': 'Report at',
  'form.reportOn': 'Report on',
  'form.reportInterval': 'Report interval',
  'notice.desc.RESTRICTION': 'The Provisional Restriction Notice informs the applicant of the document(s) required to complete the process. You may select the missing document(s) that the applicant must provide within a specified period.',
  'notice.REFUSAL': 'Refused Entry Notice',
  'notice.desc.REFUSAL': 'The applicant is refused entry into the country.',
  'notice.acknowledge': 'I hereby acknowledge receipt of this notice.',
  'notice.desc.REPORTING': 'The notice to Visitor allows the applicant to enter/leave the country but may be subject to further reporting. You may select missing document(s) that the applicant must provide within a specified period.',
  'form.stationReference': 'Station reference',
  'form.fullNames': 'Full name',
  'form.reportLocation': 'Report location',
  'form.daysUntilReport': 'Days until report',
  'form.otherMissingDocument': 'Other missing document',
  'form.residentialAddress': 'Residential address',
  'form.businessAddress': 'Business address',
  'form.hqReference': 'HQ reference',
  'residentPermit': 'Residence Permit',
  'notice.title': 'Available notices to print',
  'notice.desc': 'Please select a notice from the list below. After filling in the required fields, you can print the notice for the applicant.',
  'notice.RESTRICTION': 'Provisional Restriction Notice',
  'notice.REPORTING': 'Notice to Visitor',
  'notice.RESTRICTION.desc': 'The applicant must provide missing document(s) within a specified period.',
  'notice.REFUSAL.desc': 'The applicant is refused entry into the country.',
  'notice.REPORTING.desc': 'The applicant is allowed entry but may be subject to further reporting.',
  'passportType.kioskWarning': 'The selected nationality is under Category C regime. Please proceed to an immigration officer right now.',
  'free.charge.total': 'Total is free of charge',
  'err.entryPoints': 'An error occurred while loading the planned ports of entry',
  'summary.your_meta': 'Your data (click to open)',
  'summary.payOnline': 'I prefer to pay online now rather than at the officer\'s desk upon arrival.',
  'summary.payOnline.desc': 'Selecting the option below takes you to the payment page. If you choose not to pay online, you\'ll pay the visa fees at the officer\'s desk upon arrival for "Visa on arrival" type(s) of visa.',
  'summary.meta': '\'s data (click to open)',
  'EmergencyLastName': 'Emergency contact last name',
  'EmergencyFirstName': 'Emergency contact first name',
  'EmergencyEmail': 'Emergency contact email',
  'EmergencyPhone': 'Emergency contact phone',
  'person.name': 'Selected person\'s name',
  'DYN.identity-card': 'Identity card',
  'DYN.resident-permit': 'Temporary Residence permit',
  'DYN.identity-card.desc': 'An identity card is a government-issued document used for domestic identification purposes.',
  'DYN.resident-permit.desc': 'A Temporary Residence Permit is an official document issued by a government allowing a foreign national to reside in a country for a specified period.',
  'NonOrdinaryPassMission': 'Reason for the official visit',
  'PreviousConvictionsHomeAsk': 'Have you, or any of your dependants, been convicted of any crime in your home country?',
  'PlaceOfBirthCountry': 'Country of birth',
  'PlaceOfBirthCity': 'City of birth',
  'OtherName': 'Other name(s)',
  'travelName': 'Application reference',
  'plannedEntry': 'Planned port of entry',
  'summary.title': 'Summary',
  'urgent': 'Urgent',
  'visaType': 'Type of document',
  'passportType': 'Type of identification',
  'passportType.acknowledge': 'By selecting this passport type, you acknowledges that failure to comply with the conditions of use may result in denial of entry.',
  'passportType.selectRefugeeNationality': 'Select nationality for refugee passport',
  'form.travelName.already': '<b>This application has already been submitted with the application reference below. If you want to change the reference, please start a new application.</b>',
  'application.current_person': 'You are currently editing the application for',
  'DYN.USD': '$ USD',
  'DYN.EUR': '€ EUR',
  'DYN.ZWL': 'ZWL',
  'DYN.GBP': '£ GBP',
  'DYN.BWP': 'BWP',
  'DYN.KMF': '(KM)F',
  'participants.edit': 'Edit the applicants',
  'request.existSaved': 'A saved application has been found, would you like to load its data ? (If you click "no", the application will be deleted and you will start a new one)',
  'participant.hasData': 'You have already entered data for this participant. If you continue, the data will be lost. Are you sure you want to continue?',
  'participant.selectAtLeastOne': 'Please select at least one participant to continue.',
  'participants.title': 'Applicant(s)',
  'participants.desc': 'Please select yourself and/or the person(s) that will be part of this application.</br><b>The payment at the end will be made for all the selected persons.</b></br></br>You may add/remove a person or edit their application at any time by clicking on the name that will appear above the form.</br></br>{participantText}',
  'participant.ready': 'When you are ready, click on "Continue".',
  'participant.missing': 'Before continuing, please create at least one person.',
  'travelName.title': 'Application reference',
  'form.travelName': 'Application reference',
  'form.travelName.desc': 'The application reference will be used to identify your application more easily.',
  'nationality.title': 'Nationality',
  'nationality.desc': 'Please select your country as per the passport you are using.',
  'passportType.title': 'Document type',
  'passportType.desc': 'Please select the type of travel document you are using for this application.',
  'visaType.title': 'Visa Type',
  'visaType.desc': 'Please select the visa type you wish to apply for. This list varies depending on your nationality and type of passport.',
  'urgent.title': 'Normal/Urgent Visa',
  'urgent.desc': 'If this visa application is <b>urgent</b>, select this option. The processing time will be shorter, but an <b>additional fee</b> will be charged for this service.</br></br>',
  'priority.normal': 'Normal',
  'priority.urgent': 'Urgent',
  'priority.normal.DYN.desc': 'Processed within seven (7) working days.',
  'priority.urgent.DYN.desc': 'Processed within three (3) working days.',
  'visa.paidOnArrival.title': 'Visa paid on arrival',
  'visa.paidOnArrival.desc': 'Allows eligible travelers to obtain a visa upon arrival at the destination\'s port of entry, simplifying the entry process for short-term visits.',
  'visa.paidOnline.title': 'Visa paid online',
  'visa.paidOnline.desc': 'Allows for one or more entry into the country within a specified period of one (1) month, requiring a new visa for subsequent entries.',
  'PassportType': 'Passport type',
  'PassportCountry': 'Country issuing passport',
  'form.passportCountry': 'Country issuing passport',
  'DYN.ordinary': 'Ordinary Passport',
  'DYN.diplomatic': 'Diplomatic Passport',
  'DYN.DIPLOMATIC': 'Diplomatic Passport',
  'DYN.SERVICE': 'Service Passport',
  'DYN.ORDINARY': 'Ordinary Passport',
  'DYN.official': 'Official Passport',
  'open.register': 'Open Registry',
  'DYN.service': 'Service Passport',
  'supervision.nofee': 'Supervisor validation required for a no-penalty request.',
  'NoFeeProof': 'No fee proof',
  'webcam.nofeeProof.confirm': 'Please take a photo of the No Fee Proof document.',
  'DYN.refugee': 'Refugee Passport or Titre de Voyage',
  'DYN.ordinary.desc': 'An ordinary passport is the most common type of passport, issued to citizens for general travel purposes.',
  'DYN.diplomatic.desc': 'A diplomatic passport is issued to diplomats and consuls for official travel and residence abroad.',
  'DYN.refugee.desc': 'A refugee passport is issued by a country to people it recognizes as refugees for the purpose of travelling abroad.',
  'DYN.official.desc': 'An official passport is issued to government employees for official travel and residence abroad.',
  'DYN.service.desc': 'A service passport is issued to government employees for official travel and residence abroad.',
  'DYN.marine': 'Marine Passport',
  'DYN.marine.desc': 'A marine passport is issued to sailors and crew members for travel and residence abroad.',
  'DYN.laissez-passer': 'Laissez-passer',
  'DYN.laissez-passer.desc': 'A laissez-passer is a travel document issued by the United Nations or its agencies for official travel and residence abroad.',
  'Urgent': 'This is an urgent request. I understand that the processing time will be shorter, but the fees will be higher.',
  'photo.passport.scanned': 'Passport scanned now',
  'review.nr.final': 'Final review',
  'review.nr': 'Review nr. ',
  'err.ArrivalDate.maxDateMilliTo': 'A period of at least six (6) months between the date of expiry of your passport and the date of your arrival in the country is required. Please renew this passport before applying for a visa.',
  'err.DateOfExpiry.maxDateMilliTo': 'Your passport expires less than six (6) months from the date of the arrival in the country. Please renew this passport before applying for a visa.',
  'place.update.error': 'An error occurred while updating the place',
  'dashboard.kiosk.start': 'Start process',
  'form.role.kiosk': 'Kiosk',
  'FundsAvailable': 'Amount',
  'FundsAvailableCurrency': 'Currency',
  'emergency_contact_text': 'In case of emergency, please provide the contact details of a person who can be reached.',
  'emergency_contact': 'Emergency contact / Next of kin',
  'err.BirthDay.mustBeEqualOrBefore': 'Birth date must be equal or before date of issue of the passport',
  'err.DateOfIssue.mustBeEqualOrAfter': 'Date of issue must be equal or after date of birth',
  'internet.lost': 'Internet connection lost.</br> Please check your connection.',
  'err.DateOfExpiry.maxDateMilliFromToday': 'Your passport expires less than six (6) months from today. Please renew this passport before applying for a visa.',
  'err.DepartureDate.maxDateMilliFrom': 'The departure date is too far in the future from the arrival date. Please refer to the time limit of the visa.',
  'requirements': 'Requirements',
  'err.file.size': 'File size is too big. Maximum size is: ',
  'revision.success': 'Your request update has been successfully submitted. You will receive an email with the QR code as soon as it is approved.',
  'revision.free': 'Free revision',
  'revision.start': 'We have taken care to fill in the fields with the information you provided in the initial request, except for the fields that are causing problems. Please check the information and correct it. Would you like to continue?',
  'file_uploaded': 'File already uploaded and stored',
  'refusal.desc2': 'The following fields pose an issue:',
  'start_correction': 'Start correction',
  'payment.selectMode': 'Please select the fields that pose an issue. You can select multiple fields.',
  'suspendReason.desc': 'Please write a brief description of the revision request. This description will be sent to the requester along with the selected problem fields.',
  'err.ArrivalDate.mustBeEqualOrBefore': 'Arrival date must be equal or before departure date',
  'err.DepartureDate.mustBeEqualOrAfter': 'Departure date must be equal or after arrival date',
  'qr.request_desc': 'This QR Code acts as a digital pass for visa processing. The government reserves the right to approve or deny entry at the time of visa control.',
  'request_state.PENDING': 'Pending',
  'document.Screening': 'Screening',
  'err.SpouseBirthDay.max': 'Invalid spouse birth date',
  'err.ArrivalDate.min': 'Invalid arrival date',
  'err.DepartureDate.min': 'Invalid departure date',
  'err.DateOfIssue.max': 'Invalid date of issue',
  'err.BirthDay.max': 'Invalid birth date',
  'err.dependants_date_of_birth.max': 'Invalid dependant\'s date of birth',
  'err.DateOfExpiry.min': 'Invalid expiration date',
  'dependants': 'Dependants',
  'male': 'Male',
  'female': 'Female',
  'other': 'Other',
  'single': 'Single',
  'married': 'Married',
  'separated': 'Separated',
  'divorced': 'Divorced',
  'widowed': 'Widowed',
  'select_reason_first': 'Please select the reason for visit on the previous page to see the list of required documents.',
  'visaIntro.title': 'Application',
  'remove': 'Remove',
  'dependant_add': 'Add dependant',
  'dependant': 'Dependant',
  'upload_file': 'Upload file (< {size})',
  'PassportPhoto': 'Recent face picture',
  'PassportScan': 'Passport bio data page',
  'EventInvitationLetter': 'Event invitation letter',
  'ProofOfResidenceHost': 'Host\'s residence/booking (signed)',
  'AddressAtDestination': 'Address at destination',
  'HostInvitationLetter': 'Host invitation letter',
  'ProofOfResidence': 'Proof of residence',
  'ApplicationLetter': 'Application letter',
  'ResidentialStatusOfHost': 'Residential status of host',
  'ReasonOfVisitProof': 'Reason of visit proof',
  'BusinessLetter': 'Business letter/Individual letter',
  'BusinessProfile': 'Business profile',
  'InvitationLetterAndBusinessProfile': 'Invitation letter and host company documents (signed)',
  'InvitationLetter': 'Invitation letter',
  'LetterOfAcceptanceFromSchool': 'Confirmation letter',
  'DYN.male': 'Male',
  'DYN.female': 'Female',
  'DYN.other': 'Other',
  'DYN.single': 'Single',
  'DYN.married': 'Married',
  'DYN.separated': 'Separated',
  'DYN.divorced': 'Divorced',
  'DYN.widowed': 'Widowed',
  'DYN.married_according_to_custom': 'Married according to customs',
  'DYN.religiously_married': 'Married according to religious customs',
  'passport.valid': 'The scanned document does not appear to have been tampered with or revoked and is signed by the issuing country.',
  'travel_information_title': 'Caution',
  'visaPrice.desc': 'You will be required to make this payment by Visa or MasterCard at the end of the application. This payment is non-refundable.',
  'visaPrice': 'Visa Price',
  'required': 'Required',
  'DYN.holiday_visa': 'Holiday',
  'DYN.live_here': 'Long-term Resident',
  'DYN.business_visa': 'Business',
  'DYN.conferencing_visa': 'Conference',
  'DYN.transit_visa': 'Transit',
  'DYN.student_visa': 'Study',
  'DYN.sports_visa': 'Sport',
  'DYN.arts_visa': 'Art',
  'DYN.other_visa': 'Other',
  'DYN.event_visa': 'Event',
  'document': 'Document',
  'documents_attached': 'Documents to be attached',
  'Dependants': 'Dependants',
  'dependants_name': 'Name',
  'dependants_passport_number': 'Passport number',
  'dependants_date_of_birth': 'Date of birth',
  'dependants_place_of_birth': 'Place of birth',
  'Spouse': 'Spouse',
  'SpouseFullName': 'Spouse name',
  'SpousePassportNumber': 'Spouse passport number',
  'SpouseBirthDay': 'Spouse date of birth',
  'SpousePlaceOfBirth': 'Spouse place of birth',
  'ArrivalDate': 'Expected arrival date',
  'DepartureDate': 'Expected departure date',
  'ReferencePreviousVisa': 'Reference of previous visa',
  'PreviousConvictionsHome': 'Nature of the conviction(s) in the home country',
  'travel_information': 'Travel information',
  'DateOfIssue': 'Date of issue',
  'DateOfExpiry': 'Date of expiry',
  'PlaceofIssue': 'Place of issue',
  'Email': 'Email',
  'Phone': 'Phone Number',
  'form.selectCountry': 'Select a country',
  'Occupation': 'Occupation',
  'HomeAddress': 'Current residential address',
  'HostName': 'Host Name',
  'err.InvitingCompanyName.required': 'Inviting company name is required',
  'InvitingCompanyName': 'Inviting Company Name',
  'form.seniority': 'Seniority grade',
  'form.sex': 'Gender',
  'form.birthPlaceCountry': 'Country of birth',
  'LastName': 'Last name',
  'FirstName': 'First name(s)',
  'BirthDay': 'Date of birth (Exactly as in passport)',
  'PlaceOfBirth': 'Place of birth',
  'Gender': 'Gender',
  'MaritalStatus': 'Marital status',
  'CheckboxVisaFees': 'I confirm that the information provided is true and accurate and I agree to the visa fees, terms, and privacy policy.',
  'PassportNumber': 'Passport number',
  'Nationality': 'Nationality',
  'NationalityId': 'Nationality ID',
  'PurposeOfVisit': 'Purpose of visit',
  'VisaType': 'Visa type',
  'visitor_details': 'Applicant details',
  'personal_details': 'Personal details',
  'contact_details': 'Contact details',
  'miscellaneous_details': 'Travel details',
  'spouse_details': 'Spouse details',
  'payment': 'Payment',
  'global.scan_qr': 'Verify QR code',
  'qr.nosuch': 'Loading... QR code not found in system yet. Verify internet connection.',
  'qr.faked': 'Server response is QR code does not exist. It is highly likely a fake!',
  'qr.quicklook': 'Key information',
  'global.toPayments.DYN.': 'View applications',
  'payment.duplicate.open': 'Open the new payment ?',
  'ONE_DAY': '1 day',
  'THREE_DAYS': '3 days',
  'ONE_WEEK': '1 week',
  'TWO_WEEKS': '2 weeks',
  'ONE_MONTH': '1 month',
  'TWO_MONTHS': '2 months',
  'SIX_MONTHS': '6 months',
  'ONE_YEAR': '1 year',
  'smartTable.timeslotPlaceId': 'Timeslot place',
  'place_created.desc': 'The new place has been created and is now usable.',
  'payment_status.DYN.NONE': '-- No filter --',
  'dropdown.state': 'Status',
  'payment.qrList.title': 'List of QR payments',
  'see.qr_list': 'See the list of QR codes',
  'form.role.partner_registrer': 'Partner register',
  'form.reason': 'Reason',
  'global.reject': 'Reject',
  'payment.validate_desc': 'Are you sure you wish to validate this payment ?',
  'payment.reject_desc': 'Are you sure you wish to reject this payment ? Don\'t forget to add a reason to it',
  'qr.title': 'QR code',
  'dashboard': 'Dashboard',
  'dashboard.people.DYN.': 'Saved people',
  'dashboard.my_account': 'My account',
  'form.id': 'ID',
  'payments.scan': 'Scan QR',
  'print.qr.desc': 'This is a unique and secured QR code, can only be as many times as specified. Do not alter it to keep it usable.',
  'print.qr.title': 'QR code',
  'print.informations': 'Information',
  'print.notice.folding': 'Folding instructions',
  'print.notice.desc2': 'In case of any question relevant to this document, please contact the support by phone or email.',
  'print.notice.desc1': 'Keep this document away from water or flames.',
  'print.notice.title': 'Notice',
  'client.extended.openSuchPayment': 'A payment is already active under this user',
  'create_card_payment.fail_text': 'This might take a moment. You\'ll get notified by email once completed. The payment and QR code will be available in your Payments.',
  'form.externalId': 'Payment reference',
  'form.userExternalId': 'External ID',
  'global.confirm': 'Confirm',
  'global.submit': 'Submit',
  'global.back': 'Back',
  'global.close': 'Close',
  'global.contact_support': 'Contact support',
  'global.previous': 'Previous',
  'global.next': 'Next',
  'global.accept': 'Accept',
  'global.support': 'Support',
  'global.consume': 'Consume',
  'global.validate': 'Validate',
  'global.reset': 'Reset',
  'global.delete': 'Delete',
  'global.update': 'Update',
  'global.download': 'Download',
  'global.print': 'Print',
  'global.print_c7': 'Print ticket',
  'global.checkIn': 'Check-in',
  'choose-lang.title': 'Language preference',
  'choose-lang.desc': 'Please choose the language which will be used for this application.',
  'global.personalNum': 'Personal N°',
  'global.passportNum': 'Passport N°',
  'global.add': 'Add',
  'global.block': 'Block',
  'global.blocked': 'Bloqued',
  'global.unblock': 'Unblock',
  'global.daily_otp': 'Daily code',
  'global.refresh': 'Refresh',
  'global.connect': 'Connect',
  'global.disconnect': 'Disconnect',
  'form.email': 'Email',
  'form.name': 'Name',
  'form.firstName': 'First name(s)',
  'form.lastName': 'Last name',
  'form.password': 'Password',
  'form.password2': 'Retype password',
  'form.linkType': 'What is this person\'s link to you ?',
  'form.userId': 'User ID',
  'form.parentId': 'Parent ID',
  'form.amount': 'Amount',
  'form.currency': 'Currency',
  'form.buyingOption': 'Bought document',
  'form.place': 'Place',
  'form.role': 'Role',
  'form.connectUAPattern': 'User agent pattern',
  'form.connectIPRange': 'IP range',
  'form.state': 'State',
  'form.created_date': 'Creation date',
  'form.created_place': 'Creation place',
  'form.consumed_place': 'Consumed place',
  'form.email_code': 'Code from email',
  'form.phone': 'Phone number',
  'form.worker': 'Employee ID',
  'form.password_old': 'Current password',
  'form.password_new': 'New password',
  'form.idCard': 'ID card nr.',
  'form.type.CASH': 'Cash',
  'form.type.CARD': 'Card',
  'form.currency.KMF': 'Comorian Franc',
  'form.currency.GBP': 'Pound Sterling',
  'form.currency.BWP': 'Pula',
  'form.role.customer': 'Customer',
  'form.role.worker': 'Worker',
  'yes': 'Yes',
  'no': 'No',
  'form.borderPass': 'Issue border pass',
  'form.role.orbis_consumer': 'Orbis consumer',
  'form.role.admin': 'Admin',
  'form.perm2.DYN.': 'Consume an application',
  'form.perm3.DYN.': 'Review an application',
  'form.perm4.DYN.': 'Create/manage places, users and applications',
  'client.extended.clientNotAllowed': 'Your account is currently not allowed on this place. Please check your connection settings.',
  'err.submit': 'Error at form submition',
  'err.place.required': 'Place is required',
  'err.noSmsPerm': 'SMS right has not been granted',
  'err.noSmsReceive': 'Cannot bind to SMS lecture',
  'helps.showProceed': 'Show proceed',
  'helps.showScan': 'Show scan document',
  'payment_status.DYN.undefined': 'Current state - not an operation',
  'client.extended.missingResourceLogin': 'Unable to connect, wrong credentials',
  'client.extended.linkedAccountExists': 'Account with this email already exists',
  'client.extended.attachedPayments': 'You cannot modify this person, he/she has already a created application linked to it.',
  'client.extended.badPayload': 'Bad information in request',
  'client.extended.placeNotAllowed': 'Place is not allowed',
  'client.extended.locked': 'Account is locked',
  'client.extended.clientBadOtp': 'Bad daily code',
  'client.extended.confirmationRequired': 'Confirmation required',
  'confirmationRequired.email': 'A confirmation link has been sent to your email. Please check your inbox and confirm before signing in.',
  'confirmationRequired.sms': 'A confirmation link has been sent via SMS. Please check your messages and confirm before signing in.',
  'client.extended.badPaymentConfirmation': 'Payment cannot proceed: one of the checks failed',
  'time': 'Time',
  'place': 'Place',
  'home.first': 'Your account is now validated and you can log in.',
  'payOnline': 'Pay online',
  'login.sign_in': 'Sign in',
  'photo.unavailable': 'Picture is unavailable',
  'global.entry': 'Entry',
  'global.exit': 'Exit',
  'menu.users': 'Users',
  'menu.places': 'Places',
  'create_user.title': 'Create a user',
  'create_payment.title': 'Create a payment',
  'create_place.title': 'Create a place',
  'users.title': 'Users database',
  'payments.title': 'Payments database',
  'payments.download_csv': 'Download CSV',
  'payments.download_choice': 'What do you want to download?',
  'payments.download_table': 'Displayed table',
  'payments.download_filtered': 'Up to {value} rows',
  'create_card_payment.title': 'Online payment',
  'places.title': 'List of places',
  'forgot_password.title': 'Reset password',
  'welcome.title_1.DYN.': 'Welcome to {appName}',
  'welcome.text_1.DYN.': 'Welcome to the official {appName} portal.<br>This online service makes it easy and secure to obtain your official documents.',
  'welcome.text_1.1.DYN.': 'Ready to see how it works? Let’s get started!',
  'welcome.title_2.DYN.': 'What is {appName}?',
  'welcome.text_2.DYN.': '{appName} is a secure digital platform that allows you to request your official documents online: ID card, passport, residence permit, and more.',
  'welcome.text_2.1.DYN.': 'Apply from anywhere and receive your documents by email, with a unique QR code guaranteeing their authenticity.',
  'welcome.title_3.DYN.': 'As a worker',
  'welcome.text_3.DYN.': 'With {appName}, you can manage applications offline. We trust in our secure and reliable way of generating QR codes.',
  'welcome.text_3.1.DYN.': 'You can also manage the users and locations of your organization.',
  'welcome.text_4.DYN.': 'You can even manage applications offline. We trust in our secure and reliable way of generating QR codes.',
  'welcome.text_4.1.DYN.': 'As soon as you are back online, everything will be synced automatically.',
  'welcome.title_5.DYN.': 'Start Your Application',
  'welcome.text_5.DYN.': 'On the following pages, you can request your official documents online in just a few clicks.<br><br>After your application is approved, you will receive your documents by email, with a secure QR code containing all the information needed for quick and reliable verification.',
  'payment_status.DYN.PROPOSED': 'Pending payment',
  'payment_status.DYN.PAID': 'Ready to check-in',
  'payment_status.DYN.PAID_NOT_CONFIRMED': 'Awaiting review',
  'payment_status.DYN.USED': 'Checked out',
  'payment_status.DYN.DUPLICATED': 'Duplicated',
  'payment_status.DYN.REFUNDED': 'Refunded',
  'payment_status.DYN.EXPIRED': 'Refused',
  'payment_status.DYN.PENDING': 'Awaiting correction',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': 'Pay later - Not Confirmed',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': 'Free - Not Confirmed',
  'payment_status.DYN.DELAY_PAY': 'Ready to pay on arrival',
  'payments.validate': 'Confirm',
  'documentContinue.title': 'Continue shopping',
  'permission.no_place_found': 'You don\'t have a new place available for this user',
  'bt.available_devices': 'Available bluetooth devices',
  'bt.no_available_devices': 'No available bluetooth devices detected',
  'emailSend.title': 'Email verification',
  'emailSend.description': 'In order to validate your account, you must click on the link contained in a validation email sent to your email address within 24 hours.',
  'emailValid.title': 'Account validated',
  'emailValid.description': 'Your {appName} account has been validated successfully. You Can now access your personal space by logging in with your credentials.',
  'documentManagement.title': 'Visa application',
  'preenroll.title': 'Pre-enroll',
  'passportEmbassy.title': 'Embassy document',
  'zwevisa.title': 'Visa',
  'passwordSend.title': 'Confirmation sent',
  'passwordSend.description': 'You have received a confirmation email with a link to reset your password. You have 24 hours to click on it.',
  'forgotPassword.title': 'Forgot password',
  'forgotPassword.description': 'To reset your password, enter your account email below.',
  'forgotPassword.description.electron': 'To reset your password, enter your account email below. If you are trying to recover a password for an <b>active directory</b>  account, please contact the support.',
  'passwordNew.title': 'New password',
  'modifiedPassword.title': 'Changed password',
  'modifiedPassword.description': 'The password has been changed. Please log in again.',
  'people.title.DYN.': 'Saved people',
  'people.addPerson.DYN.': 'Create a new person',
  'meansPayment.title': 'Means of payment',
  'onlinePayment.title': 'PayPal payment',
  'onlinePayment.pay': 'Pay',
  'qrPayment.title': 'Payment by QR code',
  'form.expireDate': 'Expiration date',
  'successPayment.title': 'Order Confirmation',
  'successPayment.description2': 'Please visit the Support from your account page if you don\'t receive a notification.',
  'trackingControl.title.DYN.': 'Track this application',
  'modifyData': 'Modify datas',
  'stopModifyData': 'Stop modify datas',
  'askVisa': 'Ask a visa',
  'peopleNew.title.DYN.': 'New person',
  'peopleFound.title.DYN.': 'Person found',
  'peopleFound.description.DYN.': 'The person corresponding to the information you entered has been added to the list of saved people.',
  'payment.commandHistory': 'Payment history',
  'menu.placesPerm': 'Places and permissions',
  'block.message': 'Do you want to block this user ?',
  'menu.addPlace': 'Add a place',
  'label.numberAccount': 'N° account',
  'place.sheet.open': 'Open the place\'s sheet',
  'place.delete': 'Are you sure you want to delete this place ? This action is irreversible.',
  'place.update.success': 'The place has been successfully updated.',
  'place.new': 'New place',
  'place.create': 'Create place',
  'place.add.ask': 'Do you want to link this location to this user?',
  'place.delete.link': 'Delete the link with this place',
  'place.delete.link.ask': 'Are you sure you want to unlink this place?',
  'place.delete.link.done': 'You have successfully removed the link with the place.',
  'user.new': 'New user',
  'user.create': 'Create the user',
  'user.created': 'Creating the new user has been successful. This account can now be used.',
  'user.sheet.open': 'Open the user\'s sheet',
  'payment.sheet.open': 'Open the payment\'s sheet',
  'err.createplace': 'Unable to create. ID already exists.',
  'err.consumeLoginWeak': 'Could not log you in',
  'err.sendMagicLink': 'Could not send you the magic link',
  'place.parent': 'Parent place',
  'dropdown.qr': 'Scan a QR code',
  'dropdown.pass': 'Scan a document',
  'info.testingReader': 'Checking reader presence...',
  'info.testingReaderCard': 'Testing if reader has a chipped card...',
  'info.readingMrz': 'Reading MRZ...',
  'info.connecting': 'Connecting to chip...',
  'info.testingBAC': 'Performing Basic Access Control...',
  'info.readingCertificate': 'Reading signing certificate...',
  'info.doingPA': 'Performing Passive Authentication...',
  'info.readingDG': 'Reading data groups...',
  'info.disconnect': 'Disconnecting...',
  'info.convertingImage': 'Converting image read from document...',
  'info.searchingPayment': 'Searching for application in servers...',
  'info.readingPayment': 'Reading detailed information from server...',
  'err.noReader': 'The reader is not connected. Please connect the reader to continue.',
  'err.noCard': 'No valid biometric document detected in the reader. This may be due to the use of a non-biometric document, the presentation of an unauthorized copy or a counterfeit, or a malfunction of the reading antenna.',
  'err.noConnect': 'This document does not answer to the ICAO standard protocols. This may be due to the use of a non-biometric document, the presentation of an unauthorized copy or a counterfeit, or a malfunction of the reading antenna.',
  'err.noBAC': 'Secure channel to the document could not be established, is it genuine? Verify this document extensively manually and question the holder.',
  'err.alteredDoc': 'Document fields could not be read, is it genuine? Verify this document extensively manually and question the holder.',
  'err.revokedDocSigner': 'The signer of this document has been revoked by its issuing authority. Maybe this document was signed fraudulently. Question the holder extensively about this.',
  'err.unverifiedDoc': 'Document validity could not be verified, error in the authentication protocol, this could be a sign of a document issued outside of the country following ICAO masterlist, a counterfeit document, or a malfunction of the reading antenna.',
  'err.noPassiveAuthentication': 'Document validity could not be verified, error in the authentication protocol, a counterfeit document, or a malfunction of the reading antenna.',
  'err.noResult': 'No file found',
  'payment.new.DYN.': 'New exit without visa',
  'payment.created.register': 'Registered payment',
  'payment.created': 'Your payment has been saved and is now visible in the list of payments.',
  'payment.created.qr': 'An email containing the generated QR code has been sent to the email address provided.',
  'idcard.number': 'Identity card number',
  'form.userCreator': 'Created by the user',
  'form.userRefund': 'Reimbursed by user',
  'form.userConsumed': 'Consumed by the user',
  'PRICEUP': 'Price 0-9',
  'PRICEDOWN': 'Price 9-0',
  'RECENT': 'Most recent',
  'LATEST': 'Older',
  'STATUSUP': 'Status a-z',
  'STATUSDOWN': 'Status z-a',
  'payment.success': 'Your payment has been registered',
  'payment.consume.ask.DYN.': 'Do you really want to check-in/out this application ?',
  'checkinOut.refuse': 'Do you really want to refuse this application ?',
  'payment.duplicate': 'Duplicate',
  'payment.duplicate.ask': 'Do you really want to duplicate this payment ?',
  'payment.duplicate.done': 'Your payment has been successfully duplicated',
  'tooltip.duplicatePayment': 'Duplicate this payment to allow reuse',
  'payment.refund.ask': 'Do you really want to refund this payment ?',
  'payment.refund.done': 'Your payment has been successfully refunded',
  'payment.refund.exist': 'This payment has already been refunded',
  'payment.paid.error': 'Your payment need to be on the status \'Complete\'',
  'block.done': 'The account has been blocked',
  'block.unblock': 'The account has been unblocked',
  'place-add.add': 'Adding place',
  'permission.title': 'Permission required: Camera',
  'qr.see': 'See the QR code',
  'qr.desc.DYN.': 'Here is the QR code for the application. It will appear during a printout and will be sent to the email address entered during registration.',
  'dashboard.place.verif': 'If you have not entered a location, please do so',
  'uptodate': 'You\'re up to date',
  'block.yourself': 'You can\'t block yourself',
  'lastPlace.delete': 'The last place in this account is about to be deleted. This will render this account unusable. Continue?',
  'place.add.done': 'This place has been added to this user successfully',
  'no.connection': 'To access this page, you must be connected to the internet. Please log in again',
  'place.delete.success': 'This place has been deleted.',
  'wrong.current': 'You have entered a wrong current password',
  'no.place': 'No place for this account.',
  'email.error': 'Similar email already exist',
  'email.notexist': 'Email does not exist',
  'phone.notexist': 'Phone number does not exist',
  'one.payment': 'You must have at least one or more payments created and/or filtered.',
  'err.client.extended.uuidUsed': 'This payment has already been consumed',
  'client.extended.uuidUsed': 'This payment has already been consumed',
  'no.activecamera': 'No active camera found',
  'no.accessPermission': 'This account has no access permission',
  'print.name': 'Printer',
  'print.success': 'Your ticket has been printed',
  'print.need': 'You must first connect to a printer to be able to print',
  'printer.connect': 'You are now connected to the printer:',
  'permission.desc': 'The service you want to use requires permission to use your device\'s camera',
  'createPeople.ask.DYN.': 'Do you really want to create this new person?',
  'createPeopleDuplicate.ask.DYN.': 'It appears that a person with the same name already exists in your registered people. Do you still want to create this person?',
  'deletePerson.DYN.': 'Delete this person',
  'deletePerson.ask.DYN.': 'Are you sure you want to delete this person?',
  'deletePerson.valid.DYN.': 'The person has been deleted',
  'personModification.ask.DYN.': 'Are you sure you want to change this person\'s data ?',
  'personModification.valid.DYN.': 'The person\'s data has been modified',
  'noPayment': 'No payment',
  'selfie.desc': 'A photo is required for the document request, please ensure you are in good light and hold your phone steady to avoid a blurry image. Also, make sure that all the details of your face are clearly visible in the photo.',
  'ZWEVISA.title': 'Visa',
  'EMBASSYPASS.title': 'Embassy passport',
  'PREENROLL.title': 'Pre-enrollment',
  'DYN.NOK': 'Request refused',
  'WIP': 'Work in progress',
  'menu.requests.DYN.': 'Applications',
  'menu.createRequests.DYN.': 'New application',
  'request_state.SUBMITTED': 'Submitted',
  'request_state.CONFIRMED': 'Confirmed',
  'request_state.TREATED': 'Processed',
  'request_state.TRANSFERRED': 'Transferred',
  'request_state.CANCELLED': 'Cancelled',
  'request_state.REFUSED': 'Refused',
  'request_state.UNUSABLE': 'Unusable',
  'request_state.NULL': 'Unpaid',
  'request_state.NONE': '-- No filter --',
  'ask.disconnect': 'Are you sure you want to disconnect?',
  'global.yes': 'Yes',
  'applicant.gender.male': 'Male',
  'applicant.gender.female': 'Female',
  'applicant.gender.other': 'Other',
  'marital.status.single': 'Single',
  'marital.status.married': 'Married',
  'marital.status.separated': 'Separated',
  'marital.status.divorced': 'Divorced',
  'marital.status.married_according_to_custom': 'Married according to custom',
  'marital.status.widowed': 'Widowed',
  'marital.status.religiously_married': 'Religiously married',
  'marital.status.other': 'Other',
  'marital.status.unknown': 'Unknown',
  'PreviousVisa': 'Previous visa',
  'err.PreviousVisa.required': 'Previous visa is required',
  'multipleEntry.warning': 'Attention: Multiple entry visas are only granted to individuals who have previously obtained at least one valid visa. A copy of a previous visa will be required.',
  'request_state.PROPOSED': 'Pending payment',
  'request_state.PAID': 'Complete',
  'request_state.USED': 'Closed',
  'request_state.DUPLICATED': 'Duplicated',
  'request_state.REFUNDED': 'Refunded',
  'request_state.EXPIRED': 'Refused',
  'request_state.PAID_NOT_CONFIRMED': 'Awaiting review',
  'request_state.DELAY_PAY_NOT_CONFIRMED': 'Pay later - Not Confirmed',
  'request_state.DELAY_PAY': 'Ready to pay on arrival',
  'payment_status.DYN.0': 'Pending payment',
  'payment_status.DYN.1': 'Ready to check-in',
  'payment_status.DYN.6': 'Awaiting review',
  'payment_status.DYN.2.9': 'Awaiting supervision',
  'payment_status.DYN.2.10': 'Supervised',
  'payment_status.desc.DYN.2.10': 'The application has been reviewed by a supervisor and is ready for processing by the border control officer.',
  'payment_status.desc.DYN.2.9': 'The application is awaiting supervision. A supervisor may need to review the application before it can be processed by the border control officer.',
  'payment_status.desc.DYN.0': 'This application is currently pending payment validation at the payment institution. If the payment has not yet been made, it can be completed now.',
  'payment_status.DYN.7': 'Awaiting correction',
  'payment_status.DYN.8': 'Awaiting review & Pay later',
  'payment_status.DYN.9': 'Ready to pay on arrival',
  'payment_status.DYN.9.entry': 'Ready to check',
  'payment_status.DYN.9.exit': 'Ready to check-out',
  'payment_status.DYN.2': 'Checked out',
  'payment_status.DYN.3': 'Duplicated',
  'payment_status.DYN.4': 'Refunded',
  'payment_status.DYN.5': 'Refused',
  'payment_status.extension.DYN.5': 'Extension refused',
  'payment_status.DYN.5.blacklisted': 'Refused - Blacklisted',
  'createPeople.success.DYN.': 'Person successfully created',
  'adminRequestResult.title.DYN.': 'Selected application - {paymentID}',
  'form.paymentType': 'Payment type',
  'payment.type.online': 'Online',
  'payment.type.offline': 'Offline',
  'request.state.DYN.': 'Application status',
  'form.birthCountry': 'Country of birth',
  'form.placeOfBirth': 'City of birth',
  'form.residenceAdress': 'Residence address',
  'form.maritalStatus': 'Marital status',
  'form.departureDate': 'Departure date',
  'form.arrivalDate': 'Arrival date',
  'form.referencePreviousVisa': 'Previous visa reference',
  'form.passportNumber': 'Passport number',
  'form.hostName': 'Host name',
  'form.purposeOfVisit': 'Purpose of visit',
  'form.previousConvictionsHome': 'Previous convictions in home country',
  'form.SpousePlaceOfBirth': 'Spouse\'s place of birth',
  'form.spouse.birthDay': 'Spouse\'s date of birth',
  'form.spousePassportNumber': 'Spouse\'s passport number',
  'form.spousePlaceOfBirth': 'Spouse\'s place of birth',
  'form.dependantFullName': 'Dependant\'s full name',
  'form.dependantPassportNumber': 'Dependant\'s passport number',
  'form.dependantPlaceOfBirth': 'Dependant\'s place of birth',
  'form.dependantBirthDay': 'Dependant\'s date of birth',
  'form.existingValidEntryReferenceOfficer': 'Entry reference officer',
  'officer.unknown': 'Unknown officer',
  'global.approve': 'Approve',
  'global.refuse': 'Refuse',
  'global.suspend': 'Ask for revision',
  'personal.data': 'Personal data',
  'contact.data': 'Contact data',
  'applicant.status': 'Applicant status',
  'company.data': 'Company information',
  'divers.data.DYN.': 'Travel details',
  'dependant.data': 'Dependants',
  'spouse.data': 'Spouse data',
  'payment.review.approve.ask.DYN.': 'Do you really want to review this application as <b>RECOMMENDED</b>?',
  'payment.review.refuse.ask.DYN.': 'Do you really want to review this application as <b>NOT RECOMMENDED</b>?',
  'payment.review.refuse.ask.extension.DYN.': 'Do you really want to review this extension request as <b>NOT RECOMMENDED</b>?',
  'payment.review.approve.extension.ask.DYN.': 'Do you really want to <b>APPROVE</b> this extension request ?',
  'payment.validate.ask.DYN.': 'Do you really want to <b>APPROVE</b> this application?',
  'payment.validate.extension.ask.DYN.': 'Do you really want to <b>APPROVE</b> this extension request?',
  'error.payment.suspend.error.DYN.': 'An error occurred while suspending the application.',
  'global.no': 'No',
  'global.Yes': 'Yes',
  'global.No': 'No',
  'documents': 'Documents',
  'data.biographic': 'Passport biographic page',
  'residence.proof': 'Residence proof',
  'address.destination': 'Destination address',
  'previous.visa': 'Previous visa',
  'invite.letter': 'Invitation letter',
  'hostInvitation.letter': 'Host\'s invitation letter',
  'proof.residenceHost': 'Host\'s residence proof',
  'hostResidential.status': 'Host\'s residential status',
  'reasonOfVisit.proof': 'Proof of reason for visit to destination country',
  'inviteBusiness.letter': 'Sending company\'s business letter',
  'business.profile': 'Traveler\'s professional profile',
  'application.letter': 'Visa application letter',
  'acceptanceFromScool.letter': 'Confirmation letter',
  'date.creation': 'Creation date',
  'document.Passport': 'Passport',
  'completeName': 'Full name',
  'price': 'Price',
  'global.retry': 'Retry',
  'err.loginWeak': 'Connection problem, please try again',
  'URGENTPASS.title': 'Urgent Passport',
  'refusalReason': 'Refusal reason',
  'error.payment.noRefuseReason': 'Please enter a message.',
  'error.payment.noSuspendReason': 'Please enter a suspension reason. This reason will be sent to the customer.',
  'refusal.desc.DYN.': 'This application has been refused.',
  'refusal.desc.extension.DYN.': 'This extension request has been refused.',
  'approval.desc.DYN.': 'This application has been approved.',
  'approval.desc.extension.DYN.': 'This extension request has been approved.',
  'review.approval.desc.DYN.': 'This application meets the requirements.',
  'review.approval.desc.extension.DYN.': 'This extension request meets the requirements.',
  'review.refusal.desc.DYN.': 'This application does not meet the requirements.',
  'review.refusal.desc.extension.DYN.': 'This extension request does not meet the requirements.',
  'err.getUsers: client.extended.notActiveToken': 'Your session has expired. Please log in again.',
  'VISA_DOUBLE.title': 'Double entry visa',
  'VISA_KAZA.title': 'Visa Kaza',
  'history': 'History',
  'menu.people.DYN.': 'Saved people',
  'DYN.XBA': 'African Development Bank',
  'DYN.AGO': 'Angola',
  'DYN.ABW': 'Aruba',
  'DYN.ATG': 'Antigua & Barbuda',
  'DYN.BHS': 'Bahamas',
  'DYN.BRB': 'Barbados',
  'DYN.BLZ': 'Belize',
  'DYN.BWA': 'Botswana',
  'DYN.CYM': 'Cayman Islands',
  'DYN.CYP': 'Cyprus',
  'DYN.FJI': 'Fiji',
  'DYN.COD': 'Democratic Republic of the Congo',
  'DYN.GHA': 'Ghana',
  'DYN.GRD': 'Grenada',
  'DYN.HKG': 'Hong Kong Special Administrative Region (China)',
  'DYN.KEN': 'Kenya',
  'DYN.KIR': 'Kiribati',
  'DYN.JAM': 'Jamaica',
  'DYN.LDW': 'Leeward Islands',
  'DYN.LSO': 'Lesotho',
  'DYN.MDG': 'Madagascar',
  'DYN.MWI': 'Malawi',
  'DYN.MYS': 'Malaysia',
  'DYN.MDV': 'Maldives',
  'DYN.MLT': 'Malta',
  'DYN.MUS': 'Mauritius',
  'DYN.MSR': 'Montserrat',
  'DYN.MOZ': 'Mozambique',
  'DYN.NAM': 'Namibia',
  'DYN.NRU': 'Nauru',
  'DYN.LCA': 'Saint Lucia',
  'DYN.VCT': 'Saint Vincent and the Grenadines',
  'DYN.WSM': 'Western Samoa',
  'DYN.SYC': 'Seychelles',
  'DYN.SGP': 'Singapore',
  'DYN.SLB': 'Solomon Islands',
  'DYN.ZAF': 'South Africa',
  'DYN.KNA': 'Saint Kitts and Nevis',
  'DYN.SWZ': 'Swaziland',
  'DYN.TON': 'Tonga',
  'DYN.TTO': 'Trinidad and Tobago',
  'DYN.TCA': 'Turks and Caicos Islands',
  'DYN.TUV': 'Tuvalu',
  'DYN.UGA': 'Uganda',
  'DYN.TZA': 'United Republic of Tanzania',
  'DYN.VUT': 'Vanuatu',
  'DYN.VAT': 'Vatican',
  'DYN.VEN': 'Venezuela (Bolivarian Republic of)',
  'DYN.USA': 'United States of America',
  'DYN.URY': 'Uruguay',
  'DYN.UZB': 'Uzbekistan',
  'DYN.UKR': 'Ukraine',
  'DYN.ARE': 'United Arab Emirates',
  'DYN.GBR': 'United Kingdom of Great Britain and Northern Ireland',
  'DYN.TUR': 'Turkey',
  'DYN.TKM': 'Turkmenistan',
  'DYN.SWE': 'Sweden',
  'DYN.CHE': 'Switzerland',
  'DYN.TJK': 'Tajikistan',
  'DYN.KAZ': 'Kazakhstan',
  'DYN.SUR': 'Suriname',
  'DYN.ESP': 'Spain',
  'DYN.SVK': 'Slovakia',
  'DYN.SVN': 'Slovenia',
  'DYN.SEN': 'Senegal',
  'DYN.SRB': 'Serbia',
  'DYN.SMR': 'San Marino',
  'DYN.STP': 'Sao Tome and Principe',
  'DYN.NLD': 'Netherlands',
  'DYN.NCL': 'New Caledonia',
  'DYN.NZL': 'New Zealand',
  'DYN.NIC': 'Nicaragua',
  'DYN.MEX': 'Mexico',
  'DYN.FSM': 'Micronesia, Federated States of',
  'DYN.MDA': 'Moldova',
  'DYN.MCO': 'Monaco',
  'DYN.MHL': 'Marshall Islands',
  'DYN.LVA': 'Latvia',
  'DYN.NFK': 'Norfolk Island',
  'DYN.MNP': 'Northern Mariana Islands',
  'DYN.NOR': 'Norway',
  'DYN.PLW': 'Palau',
  'DYN.PSE': 'Palestine',
  'DYN.PAN': 'Panama',
  'DYN.PNG': 'Papua New Guinea',
  'DYN.PRY': 'Paraguay',
  'DYN.PER': 'Peru',
  'DYN.POL': 'Poland',
  'DYN.PRT': 'Portugal',
  'DYN.PRI': 'Puerto Rico',
  'DYN.REU': 'Réunion',
  'DYN.ROU': 'Romania',
  'DYN.RUS': 'Russian Federation',
  'DYN.RWA': 'Rwanda',
  'DYN.LIE': 'Liechtenstein',
  'DYN.LTU': 'Lithuania',
  'DYN.LUX': 'Luxembourg',
  'DYN.MAC': 'Macau Special Administrative Region (China)',
  'DYN.JPN': 'Japan',
  'DYN.KWT': 'Kuwait',
  'DYN.KGZ': 'Kyrgyzstan',
  'DYN.KOR': 'South Korea',
  'DYN.GUY': 'Guyana',
  'DYN.HTI': 'Haiti',
  'DYN.HND': 'Honduras',
  'DYN.IRL': 'Ireland',
  'DYN.ISR': 'Israel',
  'DYN.ITA': 'Italy',
  'DYN.HUN': 'Hungary',
  'DYN.ISL': 'Iceland',
  'DYN.IND': 'India',
  'DYN.IDN': 'Indonesia',
  'DYN.IRN': 'Iran',
  'DYN.GUM': 'Guam',
  'DYN.GTM': 'Guatemala',
  'DYN.GIB': 'Gibraltar',
  'DYN.GRC': 'Greece',
  'DYN.GEO': 'Georgia',
  'DYN.DEU': 'Germany',
  'DYN.DNK': 'Denmark',
  'DYN.EST': 'Estonia',
  'DYN.ETH': 'Ethiopia',
  'DYN.FIN': 'Finland',
  'DYN.FRA': 'France',
  'DYN.GUF': 'French Guiana',
  'DYN.PYF': 'French Polynesia',
  'DYN.ATF': 'French Southern Territories',
  'DYN.CZE': 'Czech Republic',
  'DYN.COM': 'Comoros',
  'DYN.DOM': 'Dominican Republic',
  'DYN.ECU': 'Ecuador',
  'DYN.EGY': 'Egypt',
  'DYN.SLV': 'El Salvador',
  'DYN.GNQ': 'Equatorial Guinea',
  'DYN.CHL': 'Chile',
  'DYN.CHN': 'China',
  'DYN.CHN_NT': 'China (non-touristic)',
  'DYN.COK': 'Cook Islands',
  'DYN.CRI': 'Costa Rica',
  'DYN.HRV': 'Croatia',
  'DYN.CUB': 'Cuba',
  'DYN.BDI': 'Burundi',
  'DYN.CAN': 'Canada',
  'DYN.CPV': 'Cape Verde',
  'DYN.BRA': 'Brazil',
  'DYN.VGB': 'British Virgin Islands',
  'DYN.BRN': 'Brunei Darussalam',
  'DYN.BGR': 'Bulgaria',
  'DYN.BMU': 'Bermuda',
  'DYN.BTN': 'Bhutan',
  'DYN.BIH': 'Bosnia and Herzegovina',
  'DYN.BLR': 'Belarus',
  'DYN.BEL': 'Belgium',
  'DYN.BHR': 'Bahrain',
  'DYN.ARG': 'Argentina',
  'DYN.ARM': 'Armenia',
  'DYN.AUS': 'Australia',
  'DYN.AUT': 'Austria',
  'DYN.AZE': 'Azerbaijan',
  'DYN.ALB': 'Albania',
  'DYN.DZA': 'Algeria',
  'DYN.AIA': 'Anguilla',
  'DYN.BGD': 'Bangladesh',
  'DYN.BEN': 'Benin',
  'DYN.AFG': 'Afghanistan',
  'DYN.BOL': 'Bolivia',
  'DYN.BFA': 'Burkina Faso',
  'DYN.KHM': 'Cambodia',
  'DYN.CMR': 'Cameroon',
  'DYN.CIV': "Côte d'Ivoire",
  'DYN.CAF': 'Central African Republic',
  'DYN.TCD': 'Chad',
  'DYN.COL': 'Colombia',
  'DYN.ERI': 'Eritrea',
  'DYN.COG': 'Congo-Brazzaville',
  'DYN.PRK': 'Democratic People\'s Republic of Korea',
  'DYN.GAB': 'Gabon',
  'DYN.GMB': 'Gambia',
  'DYN.DJI': 'Djibouti',
  'DYN.GIN': 'Guinea-Conakry',
  'DYN.GNB': 'Guinea-Bissau',
  'DYN.IRQ': 'Iraq',
  'DYN.KOS': 'Kosovo',
  'DYN.LAO': 'Lao People\'s Democratic Republic',
  'DYN.JOR': 'Jordan',
  'DYN.LBR': 'Liberia',
  'DYN.LBY': 'Libyan Arab Jamahiriya',
  'DYN.MLI': 'Mali',
  'DYN.QAT': 'Qatar',
  'DYN.REF': 'Refugee',
  'DYN.PHL': 'Philippines',
  'DYN.OMN': 'Oman',
  'DYN.PAK': 'Pakistan',
  'DYN.LBN': 'Lebanon',
  'DYN.MRT': 'Mauritania',
  'DYN.MNG': 'Mongolia',
  'DYN.MNE': 'Montenegro',
  'DYN.NER': 'Niger',
  'DYN.NGA': 'Nigeria',
  'DYN.MMR': 'Myanmar',
  'DYN.MAR': 'Morocco',
  'DYN.NPL': 'Nepal',
  'DYN.SAU': 'Saudi Arabia',
  'DYN.SLE': 'Sierra Leone',
  'DYN.SOM': 'Somalia',
  'DYN.LKA': 'Sri Lanka',
  'DYN.SSD': 'South Sudan',
  'DYN.SDN': 'Sudan',
  'DYN.THA': 'Thailand',
  'DYN.MKD': 'Former Yugoslav Republic of Macedonia',
  'DYN.TGO': 'Togo',
  'DYN.SYR': 'Syrian Arab Republic',
  'DYN.TWN': 'Taiwan',
  'DYN.TUN': 'Tunisia',
  'DYN.VNM': 'Vietnam',
  'DYN.YEM': 'Yemen',
  'DYN.TLS': 'Timor-Leste',
  'DYN.AND': 'Andorra',
  'DYN.VIR': 'Virgin Islands (U.S.)',
  'DYN.XKX': 'Kosovo',
  'DYN.ZWE': 'Zimbabwe',
  'DYN.ZMB': 'Zambia',
  'DYN.ASM': 'American Samoa',
  'DYN.DMA': 'Dominica',
  'DYN.XXA': 'Stateless',
  'DYN.XXB': 'Refugee (Geneva convention)',
  'DYN.XXC': 'Refugee (Other)',
  'DYN.UNA': 'United Nations Agency',
  'DYN.UNO': 'United Nations Organization',
  'DYN.role.0': 'Customer',
  'DYN.role.1': 'Employee',
  'DYN.role.2': 'Orbis Consumer',
  'DYN.role.3': 'Administrator',
  'DYN.role.4': 'Partner Registrar',
  'DYN.role.5': 'Kiosk',
  'DYN.role.6': 'External Monitor',
  'err.Occupation.pattern': 'Occupation must have a correct format',
  'err.PreviousConvictionsHome.pattern': 'Previous convictions in home country must have a correct format',
  'err.PlaceOfBirth.pattern': 'Place of birth must have a correct format',
  'document.type.DYN.': 'Application type',
  'dependantIndex': 'Dependant {index}',
  'form.spouseFullName': 'Spouse\'s Full Name',
  'qrDesc.valid': 'Present this QR code at the visa checkpoint when entering/leaving the country. You cannot travel without a valid QR code first.',
  'err.pay': 'An error occurred during payment. Try again.',
  'payment.noEvents': 'This application currently does not include any travel-related processing (usages of the application).',
  'global.cancel': 'Cancel',
  'global.loading': 'Loading',
  'end.suspend': 'Finish the revision',
  'trips.title': 'Track applications',
  'trips.desc': 'Application(s)',
  'BatchId': 'Application reference',
  'newBatchId.desc': 'Please enter a name for this travel.',
  'personLinkType.DYN.0': 'Unknown',
  'personLinkType.DYN.1': 'Child',
  'personLinkType.DYN.2': 'Parent',
  'personLinkType.DYN.3': 'Spouse',
  'personLinkType.DYN.4': 'Other',
  'personLinkType.DYN.5': 'Self',
  'batchIds.desc': 'Applications linked to the reference {trip} :',
  'trip.name': 'Application reference',
  'visaIntro.validFrom': 'Start date',
  'visaIntro.validUntil': 'Expiry date',
  'visaIntro.usageCount': 'Permitted usage(s)',
  'client.extended.passportNumberAlreadyExists': 'This passport number is already used. Please enter another one.',
  'client.extended.alreadyDecided': 'This visa application has already been reviewed by you. You cannot review it again.',
  'client.extended.outOfUsage': 'This application is <b>out of its validity period</b>',
  'global.review': 'Review',
  'error.review.noChoice': 'Please select a review state in order to continue.',
  'all.reviews': 'All reviews of this visa application',
  'all.reviews.extension': 'All reviews of this extension request',
  'validate.desc': 'This visa application has been reviewed as approved the {date} by the user',
  'printEvent.desc': 'This visa application has been printed with all of its documents the {date} by the user',
  'validate.extension.desc': 'This extension request has been reviewed as approved the {date} by the user',
  'refusal.review.desc': 'This visa application has been reviewed as refused the {date} by the user',
  'refusal.review.extension.desc': 'This extension request has been reviewed as refused the {date} by the user',
  'refusal.review.desc.blacklisted': 'This visa application has been reviewed as refused and blacklisted the {date} by the user',
  'approve.text': 'This application has been approved.',
  'pending.review.desc': 'A correction of this visa application has been requested to the applicant on the {date} by the user',
  'global.reason': 'Reason',
  'pending.desc': 'This visa application is currently awaiting correction from the customer.',
  'successRequest.title': 'Request successfully submitted',
  'amountDue': 'Price: ',
  'amountDue.total.now': 'Total due now: ',
  'amountDue.total.later': 'Total due at the officer desk: ',
  'noPrint.mobile': 'Page printing is not supported on mobile devices',
  'onArrival.reset': 'Start a new process',
  'onArrival.reset.ask': 'Do you really want to start a new process?',
  'stillHere': 'Are you still there? This process will reset itself in 20 seconds.',
  'print.request': 'Print the application',
  'EXPIRED.globalExplain': 'This request has been refused. It does not comply with our standards.',
  'payment_status.desc.DYN.7': 'This application is awaiting correction from the customer.',
  'payment_status.DYN.6.review': 'Awaiting review - {reviewCount}/2',
  'payment_status.extension.DYN.6': 'Awaiting review',
  'payment_status.extension.DYN.6.review': 'Awaiting review - {reviewCount}/1',
  'payment_status.DYN.8.review': 'Awaiting review',
  'payment_status.desc.DYN.6.review': 'This application is currently awaiting review. It has already been reviewed {reviewCount} time(s).',
  'payment_status.desc.DYN.8.review': 'This application is currently awaiting supervisor review.',
  'payment_status.DYN.6.finalReview': 'Awaiting final review',
  'payment_status.extension.DYN.6.finalReview': 'Awaiting final review',
  'payment_status.desc.DYN.6.finalReview': 'This application has been reviewed and is currently awaiting final review.',
  'payment_status.desc.DYN.5': 'This application has been refused.',
  'payment_status.desc.DYN.5.blacklisted': 'This application has been refused and the person has been blacklisted.',
  'payment_status.desc.DYN.5.checkIn': 'This application was refused during the check-in at the officer\'s desk.',
  'payment_status.desc.DYN.5.checkIn.reason': 'This application was refused during the check-in at the officer\'s desk. <p><b>Reason</b>: <br/> {reason}</p>',
  'payment_status.DYN.5.checkIn': 'Refused at check-in',
  'payment_status.desc.DYN.5.checkOut': 'This application was refused during the check-out at the officer\'s desk.',
  'payment_status.DYN.5.checkOut': 'Refused at check-out',
  'payment_status.desc.DYN.9': 'This application is ready to pay at the officer desk. The check-in can be completed after the payment.',
  'payment_status.desc.DYN.9.entry': 'This application is ready to check-in at the officer desk.',
  'payment_status.desc.DYN.9.exit': 'This application is ready for check-out and requires payment for the border pass issued at the officer\'s desk.',
  'payment_status.DYN.2.out': 'Ready to check-out',
  'payment_status.DYN.2.outFinish': 'Checked out',
  'payment_status.DYN.2.closed': 'Closed',
  'payment_status.desc.DYN.2.closed': 'This application has been closed.',
  'payment_status.desc.DYN.2.zweexit': 'This application is ready to check-out at the officer desk.',
  'payment_status.DYN.2.entryFinish': 'Checked in',
  'payment_status.DYN.2.in': 'Ready to check-in',
  'payment_status.desc.DYN.2.out': 'This application has been checked in. The next step is to check out at the officer desk.',
  'payment_status.desc.DYN.2.outFinish': 'This application has been checked out. The customer can now travel.',
  'payment_status.desc.DYN.2.entryFinish': 'This application has been checked in. The customer can now enter into the country.',
  'payment_status.desc.DYN.2.in': 'This application awaits check-in at the officer desk.',
  'payment_status.DYN.zwevisa.6.review': 'Awaiting review {reviewCount}/2',
  'payment_status.extension.DYN.zwevisa.6': 'Awaiting review',
  'payment_status.extension.DYN.zwevisa.6.review': 'Awaiting review {reviewCount}/1',
  'payment_status.DYN.zwevisa.8.review': 'Awaiting review',
  'payment_status.desc.DYN.zwevisa.6.review': 'This visa application is currently awaiting review. It has already been reviewed {reviewCount} time(s).',
  'payment_status.desc.DYN.zwevisa.8.review': 'This visa application is currently awaiting supervisor review.',
  'payment_status.DYN.zwevisa.6.finalReview': 'Awaiting final review',
  'payment_status.extension.DYN.zwevisa.6.finalReview': 'Awaiting final review',
  'payment_status.desc.DYN.zwevisa.6.finalReview': 'This visa application has been reviewed and is currently awaiting final review.',
  'payment_status.desc.DYN.zwevisa.0': 'This application is currently pending payment validation at the payment institution. If the payment has not yet been made, it can be completed now.',
  'payment_status.desc.DYN.zwevisa.7': 'This visa application is awaiting correction from the customer.',
  'payment_status.desc.DYN.zwevisa.5': 'This visa application has been refused.',
  'payment_status.desc.DYN.zwevisa.5.expired': 'This visa application has expired.',
  'payment_status.desc.extension.DYN.zwevisa.5': 'This extension request has been refused.',
  'payment_status.desc.DYN.zwevisa.5.blacklisted': 'This visa application has been refused and the person has been blacklisted.',
  'payment_status.desc.DYN.zwevisa.5.checkIn': 'This application was refused during the check-in at the officer\'s desk.',
  'payment_status.desc.DYN.zwevisa.5.checkIn.reason': 'This application was refused during the check-in at the officer\'s desk. <p><b>Reason</b>: <br/> {reason}</p>',
  'payment_status.DYN.zwevisa.5.checkIn': 'Refused at check-in',
  'payment_status.desc.DYN.zwevisa.5.checkOut': 'This application was refused during the check-out at the officer\'s desk.',
  'payment_status.DYN.zwevisa.5.checkOut': 'Refused at check-out',
  'payment_status.desc.DYN.zwevisa.9': 'This visa application is ready to pay at the officer desk. The check-in can be completed after the payment.',
  'payment_status.desc.DYN.zwevisa.9.entry': 'This application is ready to check-in at the officer desk.',
  'payment_status.desc.DYN.zwevisa.9.exit': 'This application is ready for check-out and requires payment for the border pass issued at the officer\'s desk.',
  'payment_status.DYN.zwevisa.2.out': 'Ready to check-out',
  'payment_status.DYN.zwevisa.2.outFinish': 'Checked out',
  'payment_status.DYN.zwevisa.2.closed': 'Closed',
  'payment_status.desc.DYN.zwevisa.2.closed': 'This application has been closed.',
  'payment_status.desc.DYN.zwevisa.2.zweexit': 'This application is ready to check-out at the officer desk.',
  'payment_status.DYN.zwevisa.2.entryFinish': 'Checked in',
  'payment_status.DYN.zwevisa.2.in': 'Ready to check-in',
  'payment_status.desc.DYN.zwevisa.2.out': 'This application has been checked in. The next step is to check out at the officer desk.',
  'payment_status.desc.DYN.zwevisa.2.outFinish': 'This application has been checked out. The customer can now travel.',
  'payment_status.desc.DYN.zwevisa.2.entryFinish': 'This application has been checked in. The customer can now enter into the country.',
  'payment_status.desc.DYN.zwevisa.2.in': 'This application awaits check-in at the officer desk.',
  'ask.isArrivalPaid': 'The following payment must be paid now in any of the following currencies:',
  'ask.isArrivalPaid.exit': 'The border pass must be paid now in any of the following currencies:',
  'ask.isExtension.confirm': 'Do you confirm that the payment has been made? If you confirm, please enter the payment reference, the payment method, and the currency used.',
  'ask.isArrivalPaid.confirm': 'Do you confirm that the payment has been made? If you confirm, please enter the payment reference, the payment method, and the currency used. You can also change the maximum end date of stay (You can only lower the date, choosing between 1 and {days} days).',
  'ask.isArrivalPaid.confirm.exit': 'Do you confirm that the payment has been made? If you confirm, please enter the payment reference and the currency used.',
  'ask.checkoutExpired.confirm': 'Do you confirm that the payment has been made? If you confirm, please enter the payment reference and the currency used.',
  'no_trips': 'You don\'t have any travels.',
  'err.canActivate': 'An error occured',
  'form.passportNumber.dateOfIssue': 'Date of issue of the passport',
  'form.passportNumber.dateOfExpiry': 'Date of expiry of the passport',
  'form.passportNumber.placeOfIssue': 'Place of issue of the passport',
  'nextOfKin.data': 'Emergency contact / Next of kin',
  'form.otherLinkType': 'Specify the relation link type',
  'camera.problem.manual': 'You are about to check in/out this visa application without a picture of the customer. Are you sure you want to continue?',
  'camera.problem.button': 'Problem with the camera?',
  'global.noFilter': '--No filter--',
  'zweentry': 'Entry without Visa',
  'zweentry.title': 'Entry without Visa',
  'free.charge': 'Free of charge',
  'camera.init.error': 'An error occurred while initializing the camera. Do you want to check in/out this application without a picture of the customer?',
  'error.payment.noPaymentReference': 'Please enter a payment reference, a payment method and the currency used.',
  'paymentReference.ask': 'Reference of the payment',
  'paymentReference.askExpired': 'Reference of the payment for the overstay fee',
  'session.expired': 'Your session has expired. Please log in again.',
  'phone.pattern': ' (ie: +263771234567)',
  'global.receipt.id': 'ID of the application : {paymentId}',
  'ask.place.updatePermissions': 'Are you sure you want to update the permissions of this place?',
  'place.updatePermissions.success': 'The permissions of the place have been successfully updated.',
  'err.place.updatePermissions': 'An error occurred while updating the permissions of the place.',
  'global.urgent': 'Urgent',
  'form.usageAfter': 'Valid from',
  'form.usageUntil': 'Valid until',
  'form.localUsageUntil': 'Maximum end date of stay',
  'form.timeslot': 'Time slots',
  'internalReference': 'HQ reference',
  'payment_status.DYN.6.0': 'Awaiting review 0/2',
  'payment_status.DYN.6.1': 'Awaiting review 1/2',
  'payment_status.DYN.6.2': 'Awaiting final review',
  'payment_status.DYN.8.0': 'Awaiting landing review',
  'payment_status.DYN.2.0': 'Checked in',
  'payment_status.DYN.2.4': 'Ready to check-out',
  'payment_status.DYN.2.5': 'Checked out',
  'payment_status.DYN.2.6': 'Refused at check-in',
  'payment_status.DYN.2.7': 'Refused at check-out',
  'payment_status.DYN.2.8': 'Closed',
  'payment_status.extension.DYN.6.0': 'Awaiting review 0/1',
  'payment_status.extension.DYN.6.2': 'Awaiting final review',
  'payment_status.extension.DYN.7': 'Awaiting correction',
  'payment_status.extension.DYN.9': 'Extension validated',
  'payment_status.extension.DYN.0': 'Pending payment',
  'internalReference.create': 'Add an HQ reference',
  'internalReference.edit': 'Edit the HQ reference',
  'timeslot.set': 'Set timeslot',
  'timeslot.setNew': 'Set new timeslot',
  'internalReference.ask.edit': 'Please enter the new HQ reference.',
  'internalReference.ask.create': 'Please enter the HQ reference.',
  'internalReference.done.create': 'The HQ reference has been successfully added.',
  'internalReference.done.edit': 'The HQ reference has been successfully edited.',
  'error.internalReference': 'An error occurred while adding/editing the HQ reference.',
  'error.paymentUntil.expired': 'This application is beyond its validity period. You may proceed with the checkout process for the customer; however, please be advised that a fee of USD 100 is required due to the expired status of the visa application. The payment must be made immediately in any of the following currencies: ',
  'internalReference.desc': 'Add an HQ reference to this application (e.g., 140_2024).',
  'titlePrint': 'Visa application </br> <b>{paymentID}</b>',
  'titlePrint.extension': 'Extension request </br> <b>{paymentID}</b>',
  'globalStatus.valid': 'Valid',
  'PENDING.globalExplain': 'This request is awaiting correction. Please check the information and correct it.',
  'PAID_NOT_CONFIRMED.globalExplain': 'This request is awaiting confirmation by our services.',
  'PROPOSED.globalExplain': 'This request is pending payment. If you have not validated payment yet, you may do so now.',
  'afterWithoutUntil': 'You are cleared to enter from {dateAfter} until {deadlineDate}.',
  'afterWithoutUntilAndMillis': 'You are cleared to travel from {dateAfter}.',
  'afterAndUntil': 'You are cleared to travel from {dateAfter} until {dateUntil}.',
  'photo.current': 'Current picture',
  'photo.scanned': 'Picture scanned from passport',
  'createdAt': 'Date of creation',
  'all.infos': 'Information about this application',
  'afterRefused': 'Declared travel dates : {dateAfter}.',
  'DYN.paymentError.desc.success': `<p>Your order has been successfully recorded. If any part of this application requires approval from our teams, you will be notified once this process is completed. Otherwise, please know that we have received your request.</p>
  <p><b>Thank you for choosing our services.</b></p>`,
  'successPayment.kiosk': '<p>Your application has been successfully recorded. You can now proceed to the officer\'s desk to check in.</p><p><b>Thank you for choosing our services.</b></p>',
  'sinceOneWeek': 'Please note than this visa application has been in awaiting review status for more than one week.',
  'client.extended.onlyAdminDecide': 'This visa application has already been reviewed by a worker with the same seniority as you. You cannot review it again.',
  'error.paymentUntil.before': 'The date is too early. This application will be valid from {dateAfter}.',
  'applicant.gender.FEMALE': 'Female',
  'applicant.gender.MALE': 'Male',
  'entry.consume': 'Arrivals',
  'exit.consume': 'Departures',
  'scan.noConsumeMode': 'As a border officer, you are tasked with managing both entries and exits. Please select the option corresponding to your current task: processing arrivals or managing departures.',
  'scan.office': 'No record in "Ready to check-in" status for an entry has been found for this person. This person\'s nationality is of category C, which means this person requires a visa. Please escort this person to the office to either get an urgent visa or be denied entry.',
  'scan.noVisaFound': 'No record in "Ready to check-out" status for an exit has been found for this person. Would you like to create one ready to check out ?',
  'zweexit': 'Exit without visa',
  'err.scanPassport': 'An error occurred while scanning the passport. Please make sure it is correctly inserted and try again. If the problem persists, please restart the application or contact the support.',
  'exit.register': 'Record an exit',
  'entry.register': 'Record an entry',
  'exit.create': 'Create an exit without visa',
  'exit.ask': 'Are you sure you want to register an exit without visa for this person?',
  'border': 'Officer at border',
  'global.signout': 'Sign out',
  'search.manually': 'Search application',
  'scan.applicationQr': 'Scan application Qr',
  'err.client.extended.maxUsageCountReached': 'The maximum number of usages for this application has been reached.',
  'form.firstName.scanned': 'Scanned first name(s)',
  'form.lastName.scanned': 'Scanned last name',
  'DYN.form.documentNumber.scanned': '{document} number',
  'form.gender.scanned': 'Scanned Gender',
  'form.birthDate.scanned': 'Scanned date of birth',
  'form.nationality.scanned': 'Scanned nationality',
  'form.nationality': 'Nationality',
  'scanned': 'Scanned',
  'DYN.document.P': 'Passport',
  'DYN.document.ID': 'ID card',
  'DYN.document.D': 'Driver\'s license',
  'DYN.document.IR': 'Resident permit',
  'DYN.document.IT': 'Resident permit',
  'DYN.document.OTHER': 'Document',
  'application.data': 'Application data',
  'err.ResidencePermitNumber.pattern': 'The residence permit number must contain only uppercase letters and digits',

  'no.passportPhoto': 'No photo',
  'overstay': 'Overstay',
  'method.payment': 'Payment method',
  'review.desc': 'Approve/Refuse',
  'approval.usageUntil.DYN.': 'Change expiry date (optional)',
  'scanned.list': 'List of found applications',
  'scanned.recommended': 'Recommended',
  'scanned.entriesUsed': 'entries used',
  'scanned.paid': 'Paid',
  'visa.blacklist': 'This visa application has been blacklisted. The person is not allowed to enter the country.',
  'scan.noEntryFound': 'No record in "Ready to check-in" status for an entry has been found for this person. Would you like to create one ready to check in ?',
  'global.syncing': 'Synchronizing...',
  'payment.consume.error.DYN.': 'An error occurred while processing the application.',
  'dashboard.noPreviousApplication': 'No previous application found.',
  'payment.consume.error.DYN.zwevisa': 'An error occurred while processing the application.',
  'tooltip.Qr': 'You can directly scan the QR code associated with an application to find detailed information about that application.',
  'tooltip.changeTimeslot': 'Change time slot',
  'tooltip.arrivals': 'Check this checkbox to manage arrivals as a border officer.',
  'tooltip.transit': 'Check this checkbox to manage transit as a border officer.',
  'tooltip.departures': 'Check this checkbox to manage departures as a border officer.',
  'tooltip.searchManually': 'Search for a specific application using various criteria.',
  'tooltip.signout': 'Sign out of the application.',
  'tooltip.my_account': 'Access your account settings.',
  'tooltip.dashboard': 'Access the dashboard.',
  'tooltip.createRequests': 'Create a new application.',
  'tooltip.trips': 'View the status of your applications and print the linked document if approved.',
  'tooltip.people': 'Manage the persons associated with your account.',
  'tooltip.users': 'Manage the users of the application.',
  'tooltip.places': 'Manage the places of the application.',
  'tooltip.role': 'Your role and name within the application.',
  'tooltip.exitRegister': 'Manually register an exit without a visa for a person.',
  'tooltip.entryRegister': 'Manually register an entry without a visa for a person.',
  'tooltip.support': 'Contact support for assistance with any issue.',
  'tooltip.chooseLang': 'Change the application language.',
  'tooltip.changePassword': 'Change your password.',
  'tooltip.internalReferenceNoFilter': 'Click on an internal reference, if available, to be redirected to the linked reference.',
  'tooltip.state': 'Filter the applications based on their status.',
  'tooltip.tableBatchId': 'The application reference associated with the application',
  'tooltip.tableState': 'The status of the application',
  'tooltip.tableUsageAfter': 'The application start date',
  'tooltip.tableUsageUntil': 'The expiration date of the application',
  'tooltip.history': 'The payment history of your applications.',
  'tooltip.addPerson': 'Add a new person linked to your account.',
  'tooltip.urgent': 'It means that the application is marked as urgent and should be treated as soon as possible.',
  'tooltip.operationId': 'The type of application.',
  'tooltip.purposeOfVisit': 'The purpose of the visit for this application.',
  'tooltip.amount': 'The price of this application.',
  'tooltip.paymentType': 'The type of payment for this visa application.',
  'tooltip.paymentReference': 'The reference of the payment for this visa application.',
  'tooltip.review': 'Review this visa application as approved or refused and add a comment.',
  'tooltip.revision': 'Ask the customer to correct the visa application.',
  'tooltip.approve': 'Approve this visa application as a final decision. You can also add a comment. If the term "blacklisted" is present, the person will be blacklisted.',
  'tooltip.refuse': 'Refuse this visa application as a final decision. You can also add a comment.',
  'tooltip.qrSee': 'See the QR code of this application and print the document linked to it.',
  'tooltip.internalEdit': 'Edit the internal reference of this visa application.',
  'tooltip.internalAdd': 'Add an internal reference to this application.',
  'tooltip.printApplication': 'Print the application with all the information.',
  'tooltip.allReviews': 'All the reviews of this visa application, with the date and the user who made the review.',
  'tooltip.version': 'The current version of the application.',
  'tooltip.consumeProfile.IN': 'The picture captured at the entry point.',
  'tooltip.consumeNoProfile.IN': 'No picture captured at the entry point.',
  'tooltip.consumeTime.IN': 'The date and time of the entry point.',
  'tooltip.consumePlace.IN': 'The place of the entry point.',
  'tooltip.consumeProfile.OUT': 'The picture captured at the exit point.',
  'tooltip.consumeNoProfile.OUT': 'No picture captured at the exit point.',
  'tooltip.consumeTime.OUT': 'The date and time of the exit point.',
  'tooltip.consumePlace.OUT': 'The place of the exit point.',
  'tooltip.consumeOfficer.OUT': 'The officer who checked out the person.',
  'tooltip.consumeOfficer.IN': 'The officer who checked in the person.',
  'tooltip.passportComparison': 'Information scanned from the passport. It allow you to compare the information with the actual information of the application.',
  'tooltip.classicComparison': 'Actual information of the application. It allow you to compare the information with the scanned information from the passport.',
  'tooltip.trackingApplicationReference': 'Application reference of theses applications',
  'tooltip.allTrackingInfo': 'All the information about this application',
  'tooltip.trackingPrint': 'Print the document linked to this application',
  'tooltip.docFirstName': 'Enter the first name of the person as it appears on the passport.',
  'tooltip.docLastName': 'Enter the last name of the person as it appears on the passport.',
  'tooltip.docPassportNumber': 'Enter the passport number of the person.',
  'tooltip.docLinkType': 'Select the type of relation you have with the person.',
  'tooltip.docLinkTypeOther': 'Precise the type of relation you have with the person.',
  'tooltip.applicationReferenceRequest': 'The application reference of the request. It is unique for each request, and it is generated automatically.',
  'tooltip.portEntryRequest': 'The port of entry of the request. It is the place where the person will enter the country.',
  'tooltip.otherName': 'Enter the other name of the applicant as it appears on the passport.',
  'tooltip.spouseCheckbox': 'Check this box if the applicant have a spouse, and fill the information below.',
  'tooltip.hostName': 'The name of the person/organisation who will host the applicant.',
  'tooltip.scanPassport': 'Scan the passport of the applicant to find application linked to this passport. If no application is found, you can create a new one.',
  'tooltip.passportScanned': 'The information scanned from the passport.',
  'tooltip.scannedCard': 'Similar applications found with the scanned information.',
  'scan.error': 'An error occured during the scan of the document.',
  'tooltip.webcamProblems': 'If the camera doesn\'t work correctly, you can still check in or out the application without a picture.',
  'tooltip.checkOut': 'Check-out the person of the country.',
  'tooltip.checkIn': 'Check-in the person in the country.',
  'tooltip.consumeRefuse': 'Refuse the entry or exit of the person.',
  'tooltip.finalRefuse': 'The final decision of the application. The person will not be able to enter the country.',
  'tooltip.finalApprove': 'The final decision of the application. The person will be able to enter or leave the country.',
  'tooltip.finalPending': 'The final decision of the application. The person will not be able to enter the country until the application is corrected and approved.',
  'tooltip.finalRefuseBlacklist': 'The final decision of the application. The person will not be able to enter the country and is blacklisted.',
  'photo.entryCountry.IN': 'Picture at check-in',
  'photo.entryCountry.OUT': 'Picture at check-out',
  'request.viewOutOfState.button': "Force '{consumeMode}'",
  'picture': 'Picture',
  'err.noPassiveAuthenticationCSCA': 'The document is valid, but could not be verified against its issuing authority.',
  'err.passport.expired': 'The validity of the passport has expired.',
  'externalIndexedData': 'Multiple passports found',
  'client.extended.chargedBack': 'This visa application has been charged back. The individual can still proceed with checkout, but they are required to repay the entry fee in cash only.',
  'ask.chargedBack.confirm': 'Do you confirm that the person has repaid the entry fee? If you confirm, please enter the payment reference and the currency used.',
  'error.payment.noReferenceChargedBack': 'Please enter a payment reference and the currency used.',
  'client.extended.entryChargedBack': 'This visa application has been charged back. The individual cannot proceed with check-in and must create a new entry.',
  'tooltip.syncing': 'The number of application processes currently undergoing synchronization.',
  'adChoice': 'Connection with active directory',
  'external.down': 'A service our application depends on is not currently working. Please try again later.',
  'global.connection.server': 'Service unavailable. Sorry for the inconvenience, please retry later.',
  'global.connection.timeout': 'Timeout uploading your request. Please check your internet connection and try again.',
  'global.connection.problem': 'Error uploading your request. Please check that you do not use VPNs, firewalls, that your internet connection is stable and try again.',
  'err.passport.issuedSoon': 'The passport has been issued recently (less than a month ago).',
  'global.reload': 'Reload',
  'error.passportScan': 'CertBytes(b64): <pre>{certBytes}</pre>',
  'glpi.err.noPassiveAuthenticationCSCA': 'The passport\'s certificate hash could not be found in the ICAO master list, resulting in a \'err.noPassiveAuthenticationCSCA\' error.',
  'glpi.err.unverifiedDoc': 'Failed to retrieve the certificate bytes for passive authentication; this results in an \'err.unverifiedDoc\' error.',
  'glpi.err.noPassiveAuthentication': 'Failed to perform passive authentication; this results in an \'err.noPassiveAuthentication\' error.',
  'glpi.err.noConnect': 'Failed to establish a connection with the passport chip, resulting in an \'err.noConnect\' error.',
  'glpi.err.noBAC': 'BAC failed to establish with the provided MRZ information, triggering an \'err.noBAC\' error.',
  'glpi.err.alteredDoc': 'Data Group hashes (DGS) are incorrect for one or more entries, leading to an \'err.alteredDoc\' error.',
  'glpi.err.revokedDocSigner': 'Document signer\'s certificate serial number is found on the Certificate Revocation List (CRL), resulting in an \'err.revokedDocSigner\' error.',
  'watchlistCollapse': '<p>Watchlists found - <span class="watchlistCategories">{categories}</span></p>',
  'match.type': 'Match type',
  'match.hair': 'Hair',
  'match.eyes': 'Eyes',
  'match.height': 'Height',
  'match.weight': 'Weight',
  'match.race': 'Race',
  'global.category': 'Category',
  'watchlist.alertLevel': 'Alert level of the watchlist',
  'watchlist.match': 'Match {numberMatch} | <span class="watchlistCategories">{matchCategory}</span>',
  'Nationalities': 'Nationality {index}',
  'global.score': 'Score',
  'watchlist.name': 'Name of the watchlist',
  'alias': 'Alias {index}',
  'document.number': 'Number of document {index}',
  'document.issuer': 'Issuer of document {index}',
  'document.type': 'Type of document {index}',
  'dateOfBirth': 'Date of birth {index}',
  'watchlist.marks': 'Marks',
  'watchlist.image.link': 'Link to the image found {index}',
  'image.match': 'Image matched {index}',
  'tooltip.watchlist': 'The watchlist information found for this person.',
  'watchList.category': 'Category of the watchlist',
  'watchlist.level': 'Level of alert',
  'scan.fingerprint.desc': 'When ready, click on the button below to start the process of taking the fingerprint of the person. The person must place their index finger on the scanner when the red light of the fingerprint device turns on, as indicated by the officer.',
  'scan.fingerprint.noResponse': 'No response from the fingerprint scanner. Has the person placed their finger on the scanner? Is the device properly connected?',
  'scan.fingerprint': 'Fingerprint',
  'fingerprint.scan.start': 'Scan fingerprint',
  'scan.fingerprint.success': 'The fingerprints have been successfully scanned. The quality of the fingerprint scanned is {quality}/100. You can retry the process if the quality is not sufficient.',
  'fingerprint.notAvailable': 'It seems that the fingerprint scanner is not available, or the drivers are not installed. You can still proceed with the check-in without the fingerprints.',
  'skip': 'Skip',
  'global.checkOut.fingerprint': 'Check-out with fingerprint',
  'global.checkIn.fingerprint': 'Check-in with fingerprint',
  'tooltip.checkOut.fingerprint': 'Check-out the person of the country with the fingerprint.',
  'tooltip.checkIn.fingerprint': 'Check-in the person in the country with the fingerprint.',
  'paymentError.title': 'Problem with your order',
  'DYN.paymentError.desc.fail': 'Unfortunately, the payment has failed. Please try again.',
  'DYN.paymentError.desc.error': 'Unfortunately, the payment processing has returned an error. Please contact us',
  'DYN.paymentError.desc.later': 'Unfortunately, the payment processing was temporarily declined. Please try again.',
  'tooltip.applicationId': 'The ID of the application.',
  'client.extended.missingResource': 'The resource you requested is currently unavailable. Please try again later.',
  'skip.valid': 'Autoskip reviewed steps',
  'extension.data': 'Extension data',
  'attestantAddress': 'Address of the attestant',
  'attestantEmail': 'Email of the attestant',
  'attestantID': 'ID of the attestant',
  'attestantName': 'Name of the attestant',
  'attestantPhone': 'Phone of the attestant',
  'attestantRelation': 'Relation with the attestant',
  'daysRequested': 'Number of days requested',
  'tooltip.visaApplicationReference': 'Go to the visa application linked to this extension request',
  'extend.visaReference': 'Application linked to this extension request',
  'data.copyOfEntry': 'Copy of the entry',
  'data.departureTicket': 'Departure ticket',
  'data.attestantDocument': 'Document of the attestant',
  'data.affidavitCustody': 'Custody Affidavit',
  'reasonForExtention': 'Reason for extension',
  'final.ZWEVISAEXTAB': 'This extension request need to be approved by the officer.',
  'zwevisaExtValid': 'Extension validated',
  'zwevisaExtValid.desc': 'This extension request has been validated by the officer.',
  'zwevisaExtC.review.state': 'Awaiting review',
  'zwevisaExtC.review.desc': 'This extension request is awaiting review.',
  'zwevisaExtC.finalReview.desc': 'This extension request has been reviewed and is currently awaiting final review.',
  'zwevisaExtC.finalReview.state': 'Awaiting final review',
  'onlyFinalReview': 'This application is awaiting final review.',
  'tooltip.tableLocalUsageUntil': 'The expiration date of the application refers to the maximum end date of stay.',
  'ask.localUsageUntil.confirm': 'Here you can change the maximum end date of stay. You can only lower the date, choosing between 1 and {days} days',
  'localUsageUntil.ask': 'Enter days (current date: {calculatedDate})',
  'error.bad.localUsageUntil': 'The maximum end date of stay must be lower than the current expiration date and after today.',
  'none': 'None',
  'change.password.ad': 'Having an active directory account, you are not able to change your password here. For more information, please contact the support.',
  'noticePrint.title': 'Information of the notice to Visitor printed to the customer',
  'reportingPost': 'Reporting post',
  'noticePrint.matTooltip': 'Information of the notice to Visitor printed to the customer during the check-in process',
  'notice.confirm': 'Are you sure about the information on the notice ?',
  'global.refusePrint': 'Print and submit',
  'global.nextPrint': 'Print and continue',
  'err.periodFrom.periodFromGreaterThanPeriodTo': 'The period from must be before the period to.',
  'payment.reject_reason': 'Reason for rejection',
  'err.fileSize': 'File size is too big. Maximum size is: {size}',
  'document.zafembpass': 'ZAF embassy passport',
  'preenroll': 'Pre-enroll',
  'screen': 'Screening',
  'pass': 'Passeport',
  'document.pass': 'Passport',
  'document.screen': 'Screening',
  'payment.ask.print': 'Is the receipt printed?',
  'global.no.retry': 'No (retry)',
  'print.receipt': 'Print the receipt',
  'tooltip.printReceipt': 'Print the receipt(s) of the application',
  'ask.printReceipt': 'Do you want to print the receipt dated <b>{date}</b> ?',
  'error.printReceipt': 'An error occurred while printing the receipt. Please try again.',
  'ask.selectReceipt': 'Please select the receipt you want to print.',
  'operation.OUT': 'Check-out',
  'operation.IN': 'Check-in',
  'operation.PAYMENT_FINALIZED': 'Payment finalized',
  'operation.PAYMENT_CREATED': 'Payment Created',
  'operation.PAYMENT_USED_FORCE': 'Payment used forcefully',
  'noChoice.selectedReceipt': 'Please select a receipt to print.',
  'select.receipt': 'Select the receipt',
  'receiptFor.alt': 'ReCeipt for',
  'paymentType': 'Payment type',
  'totalAmount.alt': 'Total amount',
  'totalAmount': 'Total amount',
  'date': 'Date',
  'client': 'Client',
  'desc': 'Description',
  'details': 'Details',
  'client.extended.minUsageNotMet': 'The valid until must be at least 1 day after the valid from.',
  'payment.assigned.warning': 'This application is currently in active usage by another officer (Officer: {officerId}) less than 24 hours ago. Do you still want to open this application ?',
  'lock': 'Lock',
  'tooltip.tableLockTitle': 'Active usage by officer(s)',
  'client.extended.uuidNotPaid': 'The payment has not been validated yet. Please validate the payment before proceeding.',
  'form.operationComments': 'Justify the operation',
  'borderPass.emit': 'Border pass issued',
  'tooltip.borderPass': 'The border pass is a document that allows a person to cross the border. It is used when the person does not have a passport.',
  'zweexit.title': 'Exit without visa',
  'borderPass.title': 'Border pass',
  'print.borderPass': 'Print the border pass',
  'print.borderPass.ask': 'Is the border pass printed?',
  'err.issueDate.afterExpiryDate': 'The issue date must be before the expiry date.',
  'err.BirthDay.afterExpiryDate': 'The birth date must be before the expiry date.',
  'err.BirthDay.afterIssueDate': 'The birth date must be before the issue date.',
  'apiPnrCollapse': 'PNR found',
  'apipnrResponse.match': 'Match {numberMatch}',
  'match.name': 'Name',
  'match.score.name': 'Score of the name',
  'match.flightCarrier': 'Flight carrier',
  'match.flightNumber': 'Flight number',
  'match.documentType': 'Type of document',
  'match.documentNumber': 'Number of document',
  'match.documentIssuer': 'Issuer of document',
  'match.timeType': 'Event type',
  'match.timeDate': 'Date of the event',
  'match.timeScope': 'Scope of the event',
  'match.nationality': 'Nationality',
  'match.gender': 'Gender',
  'match.uuid': 'UUID',
  'match.travelerUUID': 'Traveler UUID',
  'tooltip.apiPnr': 'The PNR information found for this person.',
  'match.documentIssued': 'Date of issue of the document',
  'match.placeIssued': 'Place of issue of the document',
  'match.documentExpiration': 'Date of expiration of the document',
  'match.documentScore': 'Score of the document',
  'match.timeScore': 'Score of the event',
  'match.flightOriginDomestic': 'Domestic origin of the flight',
  'match.flightOriginIcao': 'ICAO of the flight origin',
  'match.flightOriginLat': 'Latitude of the flight origin',
  'match.flightOriginLng': 'Longitude of the flight origin',
  'match.flightOriginIata': 'IATA of the flight origin',
  'match.flightOriginCity': 'City of the flight origin',
  'match.flightOriginState': 'State of the flight origin',
  'match.flightOriginCountry': 'Country of the flight origin',
  'match.flightOriginContinent': 'Continent of the flight origin',
  'match.flightOriginName': 'Name of the flight origin',
  'match.flightOriginTimezone': 'Timezone of the flight origin',
  'match.flightDestinationDomestic': 'Domestic destination of the flight',
  'match.flightDestinationIcao': 'ICAO of the flight destination',
  'match.flightDestinationLat': 'Latitude of the flight destination',
  'match.flightDestinationLng': 'Longitude of the flight destination',
  'match.flightDestinationIata': 'IATA of the flight destination',
  'match.flightDestinationCity': 'City of the flight destination',
  'match.flightDestinationState': 'State of the flight destination',
  'match.flightDestinationCountry': 'Country of the flight destination',
  'match.flightDestinationContinent': 'Continent of the flight destination',
  'match.flightDestinationName': 'Name of the flight destination',
  'match.flightDestinationTimezone': 'Timezone of the flight destination',
  'match.localDepartureDate': 'Local departure date',
  'match.localDepartureTime': 'Local departure time',
  'match.localDepartureTotalMinutes': 'Local departure total minutes',
  'match.localDepartureDay': 'Local departure day',
  'match.localDepartureZone': 'Local departure zone',
  'match.airportDepartureDate': 'Airport departure date',
  'match.airportDepartureTime': 'Airport departure time',
  'match.airportDepartureTotalMinutes': 'Airport departure total minutes',
  'match.airportDepartureDay': 'Airport departure day',
  'match.airportDepartureZone': 'Airport departure zone',
  'match.utcDepartureDate': 'UTC departure date',
  'match.utcDepartureTime': 'UTC departure time',
  'match.utcDepartureTotalMinutes': 'UTC departure total minutes',
  'match.utcDepartureDay': 'UTC departure day',
  'match.utcDepartureZone': 'UTC departure zone',
  'match.originalDeparture': 'Original departure',
  'match.flightDepartureUtcstr': 'Flight departure UTC',
  'match.localArrivalDate': 'Local arrival date',
  'match.localArrivalTime': 'Local arrival time',
  'match.localArrivalTotalMinutes': 'Local arrival total minutes',
  'match.localArrivalDay': 'Local arrival day',
  'match.localArrivalZone': 'Local arrival zone',
  'match.airportArrivalDate': 'Airport arrival date',
  'match.airportArrivalTime': 'Airport arrival time',
  'match.airportArrivalTotalMinutes': 'Airport arrival total minutes',
  'match.airportArrivalDay': 'Airport arrival day',
  'match.airportArrivalZone': 'Airport arrival zone',
  'match.utcArrivalDate': 'UTC arrival date',
  'match.utcArrivalTime': 'UTC arrival time',
  'match.utcArrivalTotalMinutes': 'UTC arrival total minutes',
  'match.utcArrivalDay': 'UTC arrival day',
  'match.utcArrivalZone': 'UTC arrival zone',
  'match.originalArrival': 'Original arrival',
  'match.flightArrivalUtcstr': 'Flight arrival UTC',
  'match.flightBound': 'Flight bound',
  'ask.notice': 'Print a notice to visitor or a provisional restriction notice',
  'tooltip.checkIn.notice': 'Check-in the person in the country and print the notice to visitor or a provisional restriction notice.',
  'global.checkIn.notice': 'Check-in with a notice',
  'event.downgrade': 'This application has been downgraded from <b>{previousPayment}</b> to <b>{newPayment}</b> the {date} by the user <b>{userId}</b>.',
  'form.numberPeople': 'Number of people travelling with the applicant',
  'feedbackForm': 'Feedback form',
  'form.totalSpend': 'Total spend during the stay',
  'countryPermanentResidence': 'Country of permanent residence',
  'form.feedbackComments': 'Additional comments',
  'feedback.submit': 'Submit feedback',
  'downgrade.type.label': 'Type of target visa',
  'ask.downgradeType': 'Choose the type of target visa',
  'err.approveRefuse.required': 'Please select whether to recommend or not.',
  'ask.downgrade.multiple': 'Are you sure you want to downgrade this visa to {type}?',
  'err.fundsSpend.required': 'Total spend during the stay is required',
  'err.fundsCurrency.required': 'Currency of the spend is required',
  'err.countryResidence.required': 'Country of permanent residence is required',
  'err.countryDestination.required': 'Country of destination is required',
  'err.feedbackComment.required': 'Additional comments are required',
  'feedback.submitted': 'The feedback has been successfully submitted.',
  'total': 'Total',
  'smartTable.placeId': 'Place ID',
  'smartTable.id': 'ID',
  'smartTable.userId': 'User ID',
  'smartTable.name': 'Name',
  'smartTable.role': 'Role',
  'smartTable.email': 'Email',
  'smartTable.creationDate': 'Creation date',
  'smartTable.applicationId': 'Application ID',
  'smartTable.lock': 'Lock',
  'smartTable.internalReference': 'HQ Reference',
  'smartTable.nationality': 'Nationality',
  'smartTable.batchId': 'Application reference',
  'smartTable.firstName': 'First name',
  'smartTable.delayed': 'Delayed',
  'smartTable.lastName': 'Last name',
  'smartTable.fullName': 'Full name',
  'smartTable.passportNumber': 'Passport number',
  'smartTable.isUrgent': 'Urgent',
  'smartTable.paymentStatus': 'Application status',
  'smartTable.price': 'Price',
  'smartTable.usageAfter': 'Valid from',
  'smartTable.usageUntil': 'Valid until',
  'smartTable.operationId': 'Document type',
  'smartTable.filter.applicationType': 'Application type',
  'smartTable.filter.isUrgent': 'Urgent ',
  'smartTable.filter.overstay': 'Overstay',
  'smartTable.filter.paymentStatus': 'Application status',
  'smartTable.filter.paymentExtStatus': 'Extension status',
  'smartTable.filter.createAtStart': 'From',
  'smartTable.filter.createAtEnd': 'To',
  'smartTable.filter.sinceDays': 'Since',
  'smartTable.filter.timeslotStart': 'Timeslot from',
  'smartTable.filter.timeslotEnd': 'Timeslot to',
  'time.day': '{value} day',
  'time.days': '{value} days',
  'time.week': '{value} week',
  'time.weeks': '{value} weeks',
  'time.month': '{value} month',
  'time.months': '{value} months',
  'time.year': '{value} year',
  'residencePermit.warning': 'Residence permit number <b>{permitNumber}</b> is invalid or not found in database. <br><br> Please manually verify this number against the traveler\'s physical permit before approving entry.',
  'statusLabel.toConfirm': '(to confirm)',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': 'City of birth',
  'form.birthDate': 'Date of birth',
  'form.eyeColor': 'Eye color',
  'form.hairColor': 'Hair color',
  'form.height': 'Height',
  'form.occupation': 'Occupation',
  'form.fatherFirstName': 'Father\'s first name',
  'form.fatherLastName': 'Father\'s last name',
  'form.motherFirstName': 'Mother\'s first name',
  'form.motherLastName': 'Mother\'s last name',
  'form.physical.description': 'Physical description',
  'documents.no.documents': 'No documents were found for this application',
  'OtherPurpose': 'Other purpose',
  'RegistrationType': 'Your type',
  'ManagerJobTitle': 'Manager job\'s title',
  'BusinessRegistrationNumber': 'Business registration number',
  'CompanyName': 'Company name',
  'global.naturalPerson': 'Natural person',
  'global.legalEntity': 'Legal entity',
  'DYN.GENERAL_MANAGER': 'General manager',
  'DYN.PRESIDENT_CEO': 'President and CEO',
  'DYN.HR_DIRECTOR': 'Human resource director',
  'DYN.CONSULAR_CARD': 'Consular card',
  'DYN.NATIONAL_IDENTITY_CARD': 'National identity card',
  'DYN.PASSPORT': 'Passport',
  'DYN.RESIDENT_CARD': 'Resident card',
  'IdentificationDocument': 'Identification document',
  'applicant_information': 'Applicant information',
  'applier_information': 'Applier information',
  'DYN.BROTHER': 'Brother',
  'DYN.SISTER': 'Sister',
  'DYN.MOTHER': 'Mother',
  'DYN.FATHER': 'Father',
  'DYN.GRANDFATHER': 'Grandfather',
  'DYN.GRANDMOTHER': 'Grandmother',
  'DYN.HUSBAND': 'Husband',
  'DYN.MARRY': 'Spouse',
  'DYN.CHILD': 'Child',
  'DYN.FRIEND': 'Friend',
  'DYN.COUSIN': 'Cousin',
  'DYN.FULL_ADOPTION': 'Full adoption',
  'DYN.SIMPLE_ADOPTION': 'Simple adoption',
  'DYN.EMPLOYEE': 'Employee',
  'DYN.MYSELF': 'Myself',
  'BROTHER': 'Brother',
  'SISTER': 'Sister',
  'MOTHER': 'Mother',
  'FATHER': 'Father',
  'GRANDFATHER': 'Grandfather',
  'GRANDMOTHER': 'Grandmother',
  'HUSBAND': 'Husband',
  'MARRY': 'Spouse',
  'CHILD': 'Child',
  'FRIEND': 'Friend',
  'COUSIN': 'Cousin',
  'FULL_ADOPTION': 'Full adoption',
  'SIMPLE_ADOPTION': 'Simple adoption',
  'EMPLOYEE': 'Employee',
  'MYSELF': 'Myself',
  'OTHER': 'Other',
  'DYN.MODIFICATION': 'Modification',
  'DYN.DUPLICATE': 'Duplicate',
  'DYN.WORKER': 'Worker',
  'DYN.RELIGIOUS': 'Religious',
  'DYN.SPOUSE_TAKEN_CARE_OF': 'Spouse taken care Of',
  'DYN.RETIREES': 'Retirees',
  'DYN.MERCHANTS': 'Merchants',
  'DYN.CORPORATION_WORKERS_VOLUNTEERS_FRENCH': 'Corporation workers/volunteers French',
  'DYN.FRENCH_NATIONAL': 'French national',
  'DYN.STUDENTS': 'Students',
  'DYN.CRAFTSMAN': 'Craftsman',
  'DYN.MINOR_UNDER_16': 'Minor under 16',
  'DYN.WITHDRAWN': 'Withdrawn',
  'DYN.MALE': 'Male',
  'DYN.FEMALE': 'Female',
  'RequestReason': 'Request reason',
  'LEGAL': 'Legal',
  'NATURAL': 'Individual',
  'DYN.legal': 'Legal',
  'DYN.natural': 'Individual',
  'WorkContract': 'Work contract',
  'GuardianIdCard': 'Guardian ID card',
  'guardian.data': 'Guardian data',
  'guardianManager.data': 'Guardian manager data',
  'DYN.NEW_REQUEST': 'New request',
  'DYN.RENEWAL': 'Renewal',
  'DYN.LOST': 'Lost',
  'NationalId': 'National ID',
  'IdNumber': 'ID Number',
  'BirthEntryNumber': 'Birth entry number',
  'NameChanged': 'Has your number been changed?',
  'OriginalName': 'Original name',
  'NameChangedTo': 'Name changed to',
  'NameChangeDate': 'Date of change',
  'personal_details_1': 'Personal Details - 1',
  'personal_details_2': 'Personal Details - 2',
  'EyeColor': 'Eye color',
  'HairColor': 'Hair color',
  'VisibleMark': 'Visible marks or peculiarities',
  'MarriageDate': 'Date of marriage',
  'MarriagePlace': 'Place of marriage',
  'SpouseCitizenship': 'Spouse citizenship',
  'MarriageDivorceOrderNumber': 'Marriage or divorce order number',
  'personal_details_3': 'Personal Details - 3',
  'FullName': 'Full name',
  'Relationship': 'Relationship',
  'next_of_kin': 'Next of Kin',
  'declaration': 'Declaration',
  'global.renewal': 'Renewal',
  'global.newRequest': 'New request',
  'global.lost': 'Lost',
  'DYN.BLOND': 'Blond',
  'DYN.CHESTNUT': 'Chestnut',
  'DYN.BROWN': 'Brown',
  'DYN.BLACK': 'Black',
  'DYN.RED': 'Red',
  'DYN.GRAY_WHITE': 'Gray/White',
  'DYN.OTHER': 'Other',
  'DYN.BLUE': 'Blue',
  'DYN.GRAY': 'Gray',
  'DYN.GREEN': 'Green',
  'DYN.HAZEL': 'Hazel',
  'DYN.YES': 'Yes',
  'DYN.NO': 'No',
  'DYN.NA': 'Not applicable',
  'DYN.SINGLE': 'Single',
  'DYN.MARRIED': 'Married',
  'DYN.SEPARATED': 'Separated',
  'DYN.DIVORCED': 'Divorced',
  'DYN.WIDOWED': 'Widowed',
  'DYN.MARRIED_ACCORDING_TO_CUSTOM': 'Married according to customs',
  'DYN.RELIGIOUSLY_MARRIED': 'Married according to religious customs',
  'MarriageCountry': 'Marriage country',
  'NationalityCertificate': 'Nationality certificate',
  'MarriageCertificate': 'Marriage certificate',
  'CitizenshipCertificate': 'Citizenship certificate',
  'OldPassportOrEmergencyTravelDocument': 'Old passport or emergency travel document',
  'global.N/A': 'N/A',
  'DYN.YES-FULL': 'Yes-Full',
  'DYN.YES-VALID': 'Yes-Valid',
  'DYN.YES-LOST': 'Yes-Lost',
  'DYN.YES-EXPIRED': 'Yes-Expired',
  'Height': 'Height (cm)',
  'IdNumber_desc': '',
  'err.pattern.^[0-9]+$': 'The "{fieldName}" accepts only numeric values.',
  'err.pattern.^(?:[3-9][0-9]|[12][0-9][0-9]|2[0-4][0-9]|250)$': 'The "{fieldName}" value is outside acceptable range!',
  'smartTable.registrationPortId': 'Place',
  'magicLinkLogin.title': 'Magic Link Login',
  'magicLinkLogin.description': 'Enter your email or phone number to receive a login link.',
  'magicLinkLogin.descriptionEmailOnly': 'Enter your email address to receive a login link.',
  'magicLinkLogin.descriptionSmsOnly': 'Enter your phone number to receive a login link via SMS.',
  'magicLinkLogin.email': 'Email',
  'magicLinkLogin.phone': 'Phone',
  'magicLinkLogin.country': 'Country',
  'magicLinkLogin.selectCountry': 'Select a country',
  'magicLinkLogin.sendLink': 'Send Login Link',
  'magicLinkLogin.linkSent': 'Magic link sent!',
  'magicLinkLogin.checkDevice': 'Please check your email or phone for the login link.',
  'magicLinkLogin.checkEmail': 'Please check your email for the login link.',
  'magicLinkLogin.checkSms': 'Please check your phone for the login link.',
  'magicLinkLogin.sendAnother': 'Send Another Link',
  'magicLinkLogin.backToLogin': 'Back to login form',
  'magicLinkLogin.backToSignIn': 'Back to sign in',
  'err.pattern.^0[0-9]{9}$': 'Invalid phone number',
  'err.pattern.^[0-9A-Za-z]{1,50}$': 'The "{fieldName}" field must contain at most 50 characters.',
  'mother_names_desc': '',
  'father_names_desc': '',
  'form.accountName': 'Account name',
  'form.seniority.ownPlace': 'Own place only',
  'form.seniority.allPlaces': 'All places',
  'ManagerJobTitleOther': 'Please specify the job title',
  'AttestantRelationOther': 'Please specify the relation',
  'RequestReasonOther': 'Please specify the reason',
  'RequestReasonOtherTitle': 'Other reason',
  'Status': 'Status',
  'StatusOther': 'Please specify the status',
  'CRNNIExpiryDate': 'CR/NNI expiry date',
  'CRNNI': 'CR/NNI number',
  'nav.searchFromDocument': 'Search from document',
  'tooltip.nextApplication': 'Load the next application that needs processing',
  'nextApplication.button': 'Process Next Application',
  'error.insufficientPermissions': 'Insufficient permissions to access this feature',
  'nextApplication.noMore': 'No more applications to process',
  'nextApplication.error': 'Error loading next application',
  'document.Preview': 'Document Preview',
  'DYN.ABIDJAN': 'ABIDJAN',
  'DYN.BOUAKE': 'BOUAKE',
  'DYN.DALOA': 'DALOA',
  'DYN.YAMOUSSOUKRO': 'YAMOUSSOUKRO',
  'DYN.SAN_PEDRO': 'SAN_PEDRO',
  'DYN.KORHOGO': 'KORHOGO',
  'DYN.GAGNOA': 'GAGNOA',
  'DYN.MAN': 'MAN',
  'faq': 'FAQ',
  'tooltip.faq': 'Access frequently asked questions for help',
  'traveller.history.title': 'Traveller History',
  'traveller.history.loading': 'Loading history…',
  'traveller.history.entry_exit': 'Entry / Exit',
  'traveller.history.compliance': 'Compliance',
  'traveller.history.view_more': 'View More',
  'traveller.history.collapse': 'Collapse',
  'traveller.history.no_records': 'No records found',
  'traveller.history.records': 'records',
  'traveller.history.user': 'User',
  'traveller.history.reason': 'Reason',
  'traveller.history.additional_info': 'Additional Info',
  'traveller.history.event.ENTERED_COUNTRY': 'Entered Country',
  'traveller.history.event.EXITED_COUNTRY': 'Exited Country',
  'traveller.history.event.DEPORTATION_CREATED': 'Deportation Created',
  'traveller.history.event.DEPORTATION_EDITED': 'Deportation Edited',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': 'Deportation Approved by Supervisor',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': 'Deportation Approved by Dir. Ops',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': 'Successfully Deported',
  'traveller.history.event.DEPORTATION_DECLINED': 'Deportation Declined',
  'traveller.history.event.ADDED_TO_WATCHLIST': 'Added to Watchlist',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': 'Removed from Watchlist',
  'traveller.history.event.PROSECUTION_CREATED': 'Prosecution Created',
  'traveller.history.event.ADDED_BIOMETRIC': 'Added Biometric',
  'traveller.history.event.INTERVIEW_CREATED': 'Interview Created',
  'traveller.history.event.INTERVIEW_EDITED': 'Interview Edited',
  'traveller.history.event.REFUGEE_RECORD_CREATED': 'Refugee Record Created',
  'traveller.history.event.REFUGEE_RECORD_EDITED': 'Refugee Record Edited',
  'traveller.history.visa': 'Visa',
  'traveller.history.event.VALIDATED': 'Validated',
  'traveller.history.event.REFUSED': 'Refused',
  'traveller.history.permits': 'Permits',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': 'Ordinary Residence Permit',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': 'Spouse Residence Permit',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': 'Investor Residence Permit',
  'traveller.history.permit.STUDENTS_PERMIT': 'Students Permit',
  'traveller.history.permit.SCHOLARS_PERMIT': 'Scholars Permit',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': 'Temporary Employment Permit',
  'traveller.history.permit.AUTHORITY_TO_WORK': 'Authority to Work',
  'traveller.history.permit.RESUMPTION': 'Resumption',
  'traveller.history.permit.DUAL_CITIZENSHIP': 'Dual Citizenship',
  'traveller.history.permit.REINSTATEMENT': 'Reinstatement',
  'traveller.history.permit.applicationType': 'Application Type',
  'traveller.history.permit.appType.INITIAL': 'Initial',
  'traveller.history.permit.appType.EXTENSION': 'Extension',
  'traveller.history.permit.appType.PERMANENT': 'Permanent',
  'traveller.history.permit.status.REQUESTED': 'Requested',
  'traveller.history.permit.status.APPROVED': 'Approved',
  'traveller.history.permit.status.REJECTED': 'Rejected',
  'traveller.history.permit.issueDate': 'Issue Date',
  'traveller.history.permit.expiryDate': 'Expiry Date',
  'EmploymentCertificate': 'Employment certificate',
  'print.withdrawal.place': 'Withdrawal location',
  'print.withdrawal.date': 'Withdrawal date',
  'showcase.heroTitle': 'Fast, secure & <em>digital</em><br/>eVisa experience.',
  'showcase.heroSubtitle': 'Apply, verify and travel in minutes. {name} pairs biometric identity with a government-grade decision engine — so your approval lands before you do.',
  'showcase.heroSubtitle.evisa': 'Apply, verify and travel in minutes. {name} pairs biometric identity with a government-grade decision engine — so your approval lands before you do.',
  'showcase.heroSubtitle.passport_idCard_residencePermit': 'Fill your application for a passport, national ID or residence permit online. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroSubtitle.passport_idCard': 'Apply online for a passport or national ID. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroSubtitle.passport': 'Apply online for a passport. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroSubtitle.idCard': 'Apply online for a national ID card. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroSubtitle.residencePermit': 'Apply online for a residence permit. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroSubtitle.passport_residencePermit': 'Apply online for a passport or residence permit. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroSubtitle.idCard_residencePermit': 'Apply online for a national ID or residence permit. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroCta1': 'Apply for eVisa',
  'showcase.heroCta2': 'Track application',
  'showcase.flowTitleMain': 'Four steps.<br/><em>Zero queues.</em>',
  'showcase.flowTitleSub': 'An application that travels with you.',
  'showcase.flowSubtitle': '{name} choreographs the four parts of your application into a single fluid motion, so the system does the paperwork while you do the packing.',
  'showcase.ctaTitle': 'Start your journey<br/><em>digitally.</em>',
  'showcase.ctaSubtitle': 'One application. An eVisa that lives in your pocket and a decision that lands before you do.',
  'showcase.step1.label': 'Create application',
  'showcase.step1.paneTitle': 'Fill in your details',
  'showcase.step1.paneDesc': 'Destination, travel dates, purpose of visit and port of entry…',
  'showcase.step2.label': 'Upload documents',
  'showcase.step2.paneTitle': 'Upload your passport',
  'showcase.step2.paneDesc': 'Passport scan, MRZ reading, instant field extraction…',
  'showcase.step3.label': 'Biometric verification',
  'showcase.step3.paneTitle': 'Liveness & face match',
  'showcase.step3.paneDesc': 'Liveness check, face match and sanctions screening…',
  'showcase.step4.label': 'Instant approval',
  'showcase.step4.paneTitle': 'Approved & border-ready',
  'showcase.step4.paneDesc': 'Your eVisa is signed, sealed and synced to your wallet…',
  'showcase.stat1.value': 'Encrypted',
  'showcase.stat1.label': 'end-to-end',
  'showcase.stat2.value': 'Certified',
  'showcase.stat2.label': 'secure platform',
  'showcase.portalType': 'eVisa portal',
  'showcase.tl.step1': 'Identity',
  'showcase.tl.step3': 'Decision',
  'showcase.tl.step4': 'Travel',
  'showcase.tl.step2': 'Documents',
  'showcase.marquee.issuedBy': 'Issued by sovereign authorities',
  'showcase.marquee.biometric': 'Biometric',
  'showcase.marquee.secured': 'Secured',
  'showcase.marquee.borderReady': 'Border-ready in minutes',
  'showcase.marquee.encrypted': 'End-to-end encrypted',
  'showcase.marquee.eSeal': 'Electronic qualified seal',
  'showcase.marquee.realtime': 'Real-time tracking',
  'showcase.annot.mrz': 'MRZ verified',
  'showcase.annot.biometric': 'Biometric',
  'showcase.annot.issued': 'Issued',
  'showcase.annot.secured': 'Secured',
  'showcase.howItWorks': 'How it works',
  'showcase.signIn': 'Sign in to my account',
  'showcase.scroll': 'Scroll',
  'showcase.permit.badge': 'RESIDENT',
  'showcase.permit.title': 'PERMIT',
  'showcase.permit.name': 'Residence card',
  'finger.thumb': 'Thumb',
  'finger.index': 'Index',
  'finger.middle': 'Middle',
  'finger.ring': 'Ring',
  'finger.little': 'Little',
  'finger.missing': 'Missing',
  'hand.left': 'Left hand',
  'hand.right': 'Right hand',
  'fingerprints': 'Fingerprints',
  'finger.thumbs': 'Thumbs',
  'fingers.missing': 'Missing fingers',
  'signature': 'Signature',
  'trips.helper': 'Click to view/download the QR code',
  'cancelApplication': 'Cancel application',
  'cancelled': 'Cancelled',
  'draft.cancelled.error': 'An error occurred while cancelling the application. Please try again.',
  'global.goLatest': 'Open the latest application visited',
  'paidOnline': '(Paid online)',
  'payAttention': 'I will pay attention',
  'place.countriesSelected': 'Select the countries that will require a supervised entry',
  'print.date': 'Print date',
  'print.id': 'Linked to application ID',
  'transit.consume': 'Transit'
};
